import {registerRoute as workbox_routing_registerRoute} from '/src/UefaCom/node_modules/.pnpm/workbox-routing@7.4.0/node_modules/workbox-routing/registerRoute.mjs';
import {ExpirationPlugin as workbox_expiration_ExpirationPlugin} from '/src/UefaCom/node_modules/.pnpm/workbox-expiration@7.4.0/node_modules/workbox-expiration/ExpirationPlugin.mjs';
import {StaleWhileRevalidate as workbox_strategies_StaleWhileRevalidate} from '/src/UefaCom/node_modules/.pnpm/workbox-strategies@7.4.0/node_modules/workbox-strategies/StaleWhileRevalidate.mjs';
import {NetworkFirst as workbox_strategies_NetworkFirst} from '/src/UefaCom/node_modules/.pnpm/workbox-strategies@7.4.0/node_modules/workbox-strategies/NetworkFirst.mjs';
import {enable as workbox_navigation_preload_enable} from '/src/UefaCom/node_modules/.pnpm/workbox-navigation-preload@7.4.0/node_modules/workbox-navigation-preload/enable.mjs';
import {setCacheNameDetails as workbox_core_setCacheNameDetails} from '/src/UefaCom/node_modules/.pnpm/workbox-core@7.4.0/node_modules/workbox-core/setCacheNameDetails.mjs';
import {clientsClaim as workbox_core_clientsClaim} from '/src/UefaCom/node_modules/.pnpm/workbox-core@7.4.0/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/src/UefaCom/node_modules/.pnpm/workbox-precaching@7.4.0/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */



workbox_navigation_preload_enable();

workbox_core_setCacheNameDetails({prefix: "uefacom-pwa"});


self.skipWaiting();

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "css/0l.030e699a.css",
    "revision": null
  },
  {
    "url": "css/0t.c834445f.css",
    "revision": null
  },
  {
    "url": "css/0v.c40adee0.css",
    "revision": null
  },
  {
    "url": "css/0w.e4f93fbe.css",
    "revision": null
  },
  {
    "url": "css/1z.fc2e8bc3.css",
    "revision": null
  },
  {
    "url": "css/2.68170955.css",
    "revision": null
  },
  {
    "url": "css/20.b95f7e1e.css",
    "revision": null
  },
  {
    "url": "css/2a.0c6da587.css",
    "revision": null
  },
  {
    "url": "css/2f.51b778a4.css",
    "revision": null
  },
  {
    "url": "css/2o.9d0e92d0.css",
    "revision": null
  },
  {
    "url": "css/2q.1ecfed0f.css",
    "revision": null
  },
  {
    "url": "css/2qa.a2c0f2f0.css",
    "revision": null
  },
  {
    "url": "css/2x.497f8891.css",
    "revision": null
  },
  {
    "url": "css/2z.d75239c5.css",
    "revision": null
  },
  {
    "url": "css/30.9f5a7607.css",
    "revision": null
  },
  {
    "url": "css/3j.c8463c0d.css",
    "revision": null
  },
  {
    "url": "css/3m1.420323ed.css",
    "revision": null
  },
  {
    "url": "css/3p.ca036e1f.css",
    "revision": null
  },
  {
    "url": "css/3t.33ade044.css",
    "revision": null
  },
  {
    "url": "css/3v.777e2885.css",
    "revision": null
  },
  {
    "url": "css/3w.a6b3a501.css",
    "revision": null
  },
  {
    "url": "css/42.28157733.css",
    "revision": null
  },
  {
    "url": "css/4e.17018f1e.css",
    "revision": null
  },
  {
    "url": "css/4l.3a27ee81.css",
    "revision": null
  },
  {
    "url": "css/4n.7241f2a6.css",
    "revision": null
  },
  {
    "url": "css/4v.db58c38a.css",
    "revision": null
  },
  {
    "url": "css/54.0df1871c.css",
    "revision": null
  },
  {
    "url": "css/59.51437f68.css",
    "revision": null
  },
  {
    "url": "css/5n.0dab450b.css",
    "revision": null
  },
  {
    "url": "css/5qt.c85b9f33.css",
    "revision": null
  },
  {
    "url": "css/71.d20091ad.css",
    "revision": null
  },
  {
    "url": "css/72.94cfaebb.css",
    "revision": null
  },
  {
    "url": "css/72u.73d22d8c.css",
    "revision": null
  },
  {
    "url": "css/76.6f2ad1d6.css",
    "revision": null
  },
  {
    "url": "css/7d.93cb8369.css",
    "revision": null
  },
  {
    "url": "css/7o.af5ca5b9.css",
    "revision": null
  },
  {
    "url": "css/7p.a0387fbf.css",
    "revision": null
  },
  {
    "url": "css/7pu.d00f6d44.css",
    "revision": null
  },
  {
    "url": "css/7q.ff8234cf.css",
    "revision": null
  },
  {
    "url": "css/8mr.28501f2e.css",
    "revision": null
  },
  {
    "url": "css/8r.caa3abd0.css",
    "revision": null
  },
  {
    "url": "css/8rb.e8fb3fb3.css",
    "revision": null
  },
  {
    "url": "css/9.b9ab49b9.css",
    "revision": null
  },
  {
    "url": "css/92.9c430aba.css",
    "revision": null
  },
  {
    "url": "css/9b.fa6b9f3b.css",
    "revision": null
  },
  {
    "url": "css/9e.cd236198.css",
    "revision": null
  },
  {
    "url": "css/9q.21bc6ad6.css",
    "revision": null
  },
  {
    "url": "css/9qs.e0bb925c.css",
    "revision": null
  },
  {
    "url": "css/9s.330eff15.css",
    "revision": null
  },
  {
    "url": "css/9z.720d688b.css",
    "revision": null
  },
  {
    "url": "css/a.4520c2ed.css",
    "revision": null
  },
  {
    "url": "css/a4.1fe61408.css",
    "revision": null
  },
  {
    "url": "css/a9.78c6af43.css",
    "revision": null
  },
  {
    "url": "css/a92.b138120a.css",
    "revision": null
  },
  {
    "url": "css/ab.97bd3301.css",
    "revision": null
  },
  {
    "url": "css/ak.de52b993.css",
    "revision": null
  },
  {
    "url": "css/b3.a80aefa3.css",
    "revision": null
  },
  {
    "url": "css/b8.62e61538.css",
    "revision": null
  },
  {
    "url": "css/ba.f14c8a17.css",
    "revision": null
  },
  {
    "url": "css/base.css.map?_t=bcbe5725",
    "revision": "839c71db4586a00c57cee6f9a91e6102"
  },
  {
    "url": "css/base.css?_t=bcbe5725",
    "revision": null
  },
  {
    "url": "css/bc.34b9645b.css",
    "revision": null
  },
  {
    "url": "css/bl.13c2752b.css",
    "revision": null
  },
  {
    "url": "css/bn.a95f7fbe.css",
    "revision": null
  },
  {
    "url": "css/bo.54695621.css",
    "revision": null
  },
  {
    "url": "css/bo9.e114736f.css",
    "revision": null
  },
  {
    "url": "css/c.b6edbe29.css",
    "revision": null
  },
  {
    "url": "css/ca3.581d2707.css",
    "revision": null
  },
  {
    "url": "css/cd.48fbfd33.css",
    "revision": null
  },
  {
    "url": "css/cdy.9e190093.css",
    "revision": null
  },
  {
    "url": "css/cm.0dc4a5c4.css",
    "revision": null
  },
  {
    "url": "css/cn.9f43e1fb.css",
    "revision": null
  },
  {
    "url": "css/co.dd46f81c.css",
    "revision": null
  },
  {
    "url": "css/competitions/ballondor/base.css.map?_t=1ec504ef",
    "revision": "0db3d75c692ee92c94402c720255ae2c"
  },
  {
    "url": "css/competitions/ballondor/base.css?_t=1ec504ef",
    "revision": null
  },
  {
    "url": "css/competitions/corporate/base.css.map?_t=6766c069",
    "revision": "f099456f5dc79c5106dae21769786f1e"
  },
  {
    "url": "css/competitions/corporate/base.css?_t=6766c069",
    "revision": null
  },
  {
    "url": "css/competitions/corporate/sections/about.css.map?_t=e743aa95",
    "revision": "55d7416a202aaa551c1b66a0d034dd44"
  },
  {
    "url": "css/competitions/corporate/sections/about.css?_t=e743aa95",
    "revision": null
  },
  {
    "url": "css/competitions/corporate/sections/development.css.map?_t=c15f743b",
    "revision": "33e72ef2db0b1c2dd000dbf65d122053"
  },
  {
    "url": "css/competitions/corporate/sections/development.css?_t=c15f743b",
    "revision": null
  },
  {
    "url": "css/competitions/corporate/sections/jobs.css.map?_t=ca5c2e76",
    "revision": "534897cece6709ac5f8e69c2f44e8695"
  },
  {
    "url": "css/competitions/corporate/sections/jobs.css?_t=ca5c2e76",
    "revision": null
  },
  {
    "url": "css/competitions/corporate/sections/news-media.css.map?_t=f9825803",
    "revision": "849906fe11620972540af9daad7c8680"
  },
  {
    "url": "css/competitions/corporate/sections/news-media.css?_t=f9825803",
    "revision": null
  },
  {
    "url": "css/competitions/corporate/sections/running-competitions.css.map?_t=79d32454",
    "revision": "da51d5ff2d405518e869664807256db3"
  },
  {
    "url": "css/competitions/corporate/sections/running-competitions.css?_t=79d32454",
    "revision": null
  },
  {
    "url": "css/competitions/corporate/sections/sustainability.css.map?_t=15fa8a9b",
    "revision": "71e206a951a793295ca53b2541a4c066"
  },
  {
    "url": "css/competitions/corporate/sections/sustainability.css?_t=15fa8a9b",
    "revision": null
  },
  {
    "url": "css/competitions/corporate/thirdparties.css.map?_t=4a9fdcbd",
    "revision": "2cc9ffa4d6a36b7273a9d4a09d537f01"
  },
  {
    "url": "css/competitions/corporate/thirdparties.css?_t=4a9fdcbd",
    "revision": null
  },
  {
    "url": "css/competitions/euroqualifiers/base.css.map?_t=a1074c61",
    "revision": "d9893bcb965f99410f8891323bc38b90"
  },
  {
    "url": "css/competitions/euroqualifiers/base.css?_t=a1074c61",
    "revision": null
  },
  {
    "url": "css/competitions/euroqualifiers/thirdparties.css.map?_t=ed2e1660",
    "revision": "01a5434d0ee6954a9095f893569e51bd"
  },
  {
    "url": "css/competitions/euroqualifiers/thirdparties.css?_t=ed2e1660",
    "revision": null
  },
  {
    "url": "css/competitions/finalissima/base.css.map?_t=baf1629d",
    "revision": "473bdd842dda5b39cb3afd5eeee11bb0"
  },
  {
    "url": "css/competitions/finalissima/base.css?_t=baf1629d",
    "revision": null
  },
  {
    "url": "css/competitions/finalissima/thirdparties.css.map?_t=915922fc",
    "revision": "b7dee20df9c8edd201aec4239e126e45"
  },
  {
    "url": "css/competitions/finalissima/thirdparties.css?_t=915922fc",
    "revision": null
  },
  {
    "url": "css/competitions/futsaleuro/base.css.map?_t=e0dea73d",
    "revision": "eb405e3698405d5d73331ad03de8e664"
  },
  {
    "url": "css/competitions/futsaleuro/base.css?_t=e0dea73d",
    "revision": null
  },
  {
    "url": "css/competitions/futsaleuro/sections/event-guide.css.map?_t=c4b8dc65",
    "revision": "4bdd01dab6cf99d443ffe1e3e534b0d5"
  },
  {
    "url": "css/competitions/futsaleuro/sections/event-guide.css?_t=c4b8dc65",
    "revision": null
  },
  {
    "url": "css/competitions/futsaleuro/sections/top-scorer.css.map?_t=c05e01e4",
    "revision": "590b1cb7c87fa74fad49f29e5f5934ad"
  },
  {
    "url": "css/competitions/futsaleuro/sections/top-scorer.css?_t=c05e01e4",
    "revision": null
  },
  {
    "url": "css/competitions/futsaleuro/thirdparties.css.map?_t=840a5adf",
    "revision": "e9a647b0581fbe16dc8993ad53a940a9"
  },
  {
    "url": "css/competitions/futsaleuro/thirdparties.css?_t=840a5adf",
    "revision": null
  },
  {
    "url": "css/competitions/futsalfinalissima/base.css.map?_t=094190dd",
    "revision": "1e4823d3764b59f5cb6c1f406486d338"
  },
  {
    "url": "css/competitions/futsalfinalissima/base.css?_t=094190dd",
    "revision": null
  },
  {
    "url": "css/competitions/futsalfinalissima/thirdparties.css.map?_t=7c3008ed",
    "revision": "6241e32b02ea492cb0664424cf6ab393"
  },
  {
    "url": "css/competitions/futsalfinalissima/thirdparties.css?_t=7c3008ed",
    "revision": null
  },
  {
    "url": "css/competitions/futsalunder19/base.css.map?_t=0d72ba37",
    "revision": "c9b5999bded53350bb92537bad358508"
  },
  {
    "url": "css/competitions/futsalunder19/base.css?_t=0d72ba37",
    "revision": null
  },
  {
    "url": "css/competitions/futsalunder19/thirdparties.css.map?_t=3b5a6ca8",
    "revision": "157b446bc2c20d5a5dd2a53cf93bc0cf"
  },
  {
    "url": "css/competitions/futsalunder19/thirdparties.css?_t=3b5a6ca8",
    "revision": null
  },
  {
    "url": "css/competitions/futsalworldcup/base.css.map?_t=064ac7e2",
    "revision": "d7f674cab56013b2fe58722936be7d45"
  },
  {
    "url": "css/competitions/futsalworldcup/base.css?_t=064ac7e2",
    "revision": null
  },
  {
    "url": "css/competitions/futsalworldcup/thirdparties.css.map?_t=a814224f",
    "revision": "911fdd1779c8d7caf9a0841c146dde63"
  },
  {
    "url": "css/competitions/futsalworldcup/thirdparties.css?_t=a814224f",
    "revision": null
  },
  {
    "url": "css/competitions/insideuefa/base.css.map?_t=abb909f6",
    "revision": "f2302177e65b559c1e59e928c298a3c4"
  },
  {
    "url": "css/competitions/insideuefa/base.css?_t=abb909f6",
    "revision": null
  },
  {
    "url": "css/competitions/insideuefa/disciplinary.css.map?_t=933b2375",
    "revision": "85b2aa25233ba724dffaa8f1ff5bbb2c"
  },
  {
    "url": "css/competitions/insideuefa/disciplinary.css?_t=933b2375",
    "revision": null
  },
  {
    "url": "css/competitions/insideuefa/sections/careers.css.map?_t=2d0d2dd9",
    "revision": "2e3aeab9fd03ff1e7a3114fc42b85a9b"
  },
  {
    "url": "css/competitions/insideuefa/sections/careers.css?_t=2d0d2dd9",
    "revision": null
  },
  {
    "url": "css/competitions/insideuefa/sections/disciplinary-cards.css.map?_t=f8289ecf",
    "revision": "85623eeb5b89bc8e5db811ff1fb093ec"
  },
  {
    "url": "css/competitions/insideuefa/sections/disciplinary-cards.css?_t=f8289ecf",
    "revision": null
  },
  {
    "url": "css/competitions/insideuefa/sections/disciplinary-minisite-navigation.css.map?_t=5b65b65f",
    "revision": "d98c73f665f26fd7ebe432132697f033"
  },
  {
    "url": "css/competitions/insideuefa/sections/disciplinary-minisite-navigation.css?_t=5b65b65f",
    "revision": null
  },
  {
    "url": "css/competitions/insideuefa/sections/return-to-play.css.map?_t=aa4ab86d",
    "revision": "420dfc01e28238e797165120d65a1eb6"
  },
  {
    "url": "css/competitions/insideuefa/sections/return-to-play.css?_t=aa4ab86d",
    "revision": null
  },
  {
    "url": "css/competitions/insideuefa/sections/stadium-bans.css.map?_t=802e3983",
    "revision": "eaf60c55727903965ccb94807470e58d"
  },
  {
    "url": "css/competitions/insideuefa/sections/stadium-bans.css?_t=802e3983",
    "revision": null
  },
  {
    "url": "css/competitions/insideuefa/thirdparties.css.map?_t=0ea6b7b5",
    "revision": "937f522406a878f9b9df99a9fc5ac397"
  },
  {
    "url": "css/competitions/insideuefa/thirdparties.css?_t=0ea6b7b5",
    "revision": null
  },
  {
    "url": "css/competitions/myuefa/base.css.map?_t=8721949e",
    "revision": "fb8e795b323358902499937fedcb8a8c"
  },
  {
    "url": "css/competitions/myuefa/base.css?_t=8721949e",
    "revision": null
  },
  {
    "url": "css/competitions/playmakers/base.css.map?_t=f42d21dc",
    "revision": "6aa6b2051194f95f59eabf6a5738e0ea"
  },
  {
    "url": "css/competitions/playmakers/base.css?_t=f42d21dc",
    "revision": null
  },
  {
    "url": "css/competitions/regionscup/base.css.map?_t=3ceb2806",
    "revision": "62840d7b9a2ea12fbbb3dcbaaf1634a5"
  },
  {
    "url": "css/competitions/regionscup/base.css?_t=3ceb2806",
    "revision": null
  },
  {
    "url": "css/competitions/regionscup/thirdparties.css.map?_t=925819ec",
    "revision": "1537d78a00046681f6957e22e4ed64f4"
  },
  {
    "url": "css/competitions/regionscup/thirdparties.css?_t=925819ec",
    "revision": null
  },
  {
    "url": "css/competitions/supercup/base.css.map?_t=154e00dd",
    "revision": "d11e862527db4ad99d24fd1f6974e497"
  },
  {
    "url": "css/competitions/supercup/base.css?_t=154e00dd",
    "revision": null
  },
  {
    "url": "css/competitions/supercup/thirdparties.css.map?_t=ed098f05",
    "revision": "9f77fcce5136723b8a3a563e314de728"
  },
  {
    "url": "css/competitions/supercup/thirdparties.css?_t=ed098f05",
    "revision": null
  },
  {
    "url": "css/competitions/uc3/base.css.map?_t=bb48e875",
    "revision": "dfc420aee13544d86f2da04ffdd8e9c7"
  },
  {
    "url": "css/competitions/uc3/base.css?_t=bb48e875",
    "revision": null
  },
  {
    "url": "css/competitions/uefachampionsleague/base.css.map?_t=dbc658a0",
    "revision": "508fd3ff48f38e5709cd5b7c8e0634f4"
  },
  {
    "url": "css/competitions/uefachampionsleague/base.css?_t=dbc658a0",
    "revision": null
  },
  {
    "url": "css/competitions/uefachampionsleague/thirdparties.css.map?_t=bf2399c8",
    "revision": "0dc91726e4c9205adff5e0340b304026"
  },
  {
    "url": "css/competitions/uefachampionsleague/thirdparties.css?_t=bf2399c8",
    "revision": null
  },
  {
    "url": "css/competitions/uefaconmebolclubchallenge/base.css.map?_t=e78ae511",
    "revision": "dc26eec24754392c573b9b85372fb457"
  },
  {
    "url": "css/competitions/uefaconmebolclubchallenge/base.css?_t=e78ae511",
    "revision": null
  },
  {
    "url": "css/competitions/uefaconmebolclubchallenge/thirdparties.css.map?_t=ed9a38aa",
    "revision": "faedec4752b890355a5972a02590b777"
  },
  {
    "url": "css/competitions/uefaconmebolclubchallenge/thirdparties.css?_t=ed9a38aa",
    "revision": null
  },
  {
    "url": "css/competitions/uefaeuro2024/base.css.map?_t=c87db5fa",
    "revision": "9f9d1c476338dd7eb4668d4ec987e078"
  },
  {
    "url": "css/competitions/uefaeuro2024/base.css?_t=c87db5fa",
    "revision": null
  },
  {
    "url": "css/competitions/uefaeuro2024/sections/event-guide.css.map?_t=e696dacb",
    "revision": "7b3abb962eb6a3ff1a014df6b2d8db56"
  },
  {
    "url": "css/competitions/uefaeuro2024/sections/event-guide.css?_t=e696dacb",
    "revision": null
  },
  {
    "url": "css/competitions/uefaeuro2024/thirdparties.css.map?_t=7f6e94de",
    "revision": "7188d3ac7afe01a7445ae8dca2bc2eb3"
  },
  {
    "url": "css/competitions/uefaeuro2024/thirdparties.css?_t=7f6e94de",
    "revision": null
  },
  {
    "url": "css/competitions/uefaeuro2028/base.css.map?_t=88ea3a0b",
    "revision": "ba4263c689aa47e68370d1f01a158743"
  },
  {
    "url": "css/competitions/uefaeuro2028/base.css?_t=88ea3a0b",
    "revision": null
  },
  {
    "url": "css/competitions/uefaeuro2028/sections/event-guide.css.map?_t=ed671b22",
    "revision": "bbffe9b7e0cc47fefcfcbfb244317436"
  },
  {
    "url": "css/competitions/uefaeuro2028/sections/event-guide.css?_t=ed671b22",
    "revision": null
  },
  {
    "url": "css/competitions/uefaeuro2028/thirdparties.css.map?_t=2f91c407",
    "revision": "4007f2e73b6cbd337751097304aa6640"
  },
  {
    "url": "css/competitions/uefaeuro2028/thirdparties.css?_t=2f91c407",
    "revision": null
  },
  {
    "url": "css/competitions/uefaeuropaconferenceleague/base.css.map?_t=f3f68fcf",
    "revision": "4a2051451e710f613a099b6dbde5cdfa"
  },
  {
    "url": "css/competitions/uefaeuropaconferenceleague/base.css?_t=f3f68fcf",
    "revision": null
  },
  {
    "url": "css/competitions/uefaeuropaconferenceleague/thirdparties.css.map?_t=0ea1ce27",
    "revision": "ec3fe757a5d67da5831dc809e8867bd3"
  },
  {
    "url": "css/competitions/uefaeuropaconferenceleague/thirdparties.css?_t=0ea1ce27",
    "revision": null
  },
  {
    "url": "css/competitions/uefaeuropaleague/base.css.map?_t=b7fc1ce6",
    "revision": "609a2972974962996aca6206ef819c0f"
  },
  {
    "url": "css/competitions/uefaeuropaleague/base.css?_t=b7fc1ce6",
    "revision": null
  },
  {
    "url": "css/competitions/uefaeuropaleague/thirdparties.css.map?_t=69500c05",
    "revision": "fa8bed867ea504db57f38f2eadf584bd"
  },
  {
    "url": "css/competitions/uefaeuropaleague/thirdparties.css?_t=69500c05",
    "revision": null
  },
  {
    "url": "css/competitions/uefafutsalchampionsleague/base.css.map?_t=e8a9731e",
    "revision": "6abe0142b86321e2fddbc7fe1bcb24c2"
  },
  {
    "url": "css/competitions/uefafutsalchampionsleague/base.css?_t=e8a9731e",
    "revision": null
  },
  {
    "url": "css/competitions/uefafutsalchampionsleague/thirdparties.css.map?_t=406e939d",
    "revision": "e563fa2bc6845e80a42882dd71e90ec2"
  },
  {
    "url": "css/competitions/uefafutsalchampionsleague/thirdparties.css?_t=406e939d",
    "revision": null
  },
  {
    "url": "css/competitions/uefanationsleague/base.css.map?_t=f87cfae9",
    "revision": "6934db763d98d5a9cd32f762cc5fed03"
  },
  {
    "url": "css/competitions/uefanationsleague/base.css?_t=f87cfae9",
    "revision": null
  },
  {
    "url": "css/competitions/uefanationsleague/sections/gott.css.map?_t=48fb16d4",
    "revision": "51c45b0bdebc458a0b9beb3d3246ab33"
  },
  {
    "url": "css/competitions/uefanationsleague/sections/gott.css?_t=48fb16d4",
    "revision": null
  },
  {
    "url": "css/competitions/uefanationsleague/sections/top-scorer.css.map?_t=e109e8f6",
    "revision": "11840e47caf3047477436e336577a5dd"
  },
  {
    "url": "css/competitions/uefanationsleague/sections/top-scorer.css?_t=e109e8f6",
    "revision": null
  },
  {
    "url": "css/competitions/uefanationsleague/thirdparties.css.map?_t=6723d9d8",
    "revision": "26031386559580625d78674f772568b3"
  },
  {
    "url": "css/competitions/uefanationsleague/thirdparties.css?_t=6723d9d8",
    "revision": null
  },
  {
    "url": "css/competitions/under17/base.css.map?_t=fa0d1480",
    "revision": "5e081319b92e89372ed1855635373f0c"
  },
  {
    "url": "css/competitions/under17/base.css?_t=fa0d1480",
    "revision": null
  },
  {
    "url": "css/competitions/under17/thirdparties.css.map?_t=0f5d9a84",
    "revision": "08fa4a0b8e94e4fd3e9babff51aaf2aa"
  },
  {
    "url": "css/competitions/under17/thirdparties.css?_t=0f5d9a84",
    "revision": null
  },
  {
    "url": "css/competitions/under19/base.css.map?_t=8283a4af",
    "revision": "5a311e377a2e8ce87aa4d38172b6aea9"
  },
  {
    "url": "css/competitions/under19/base.css?_t=8283a4af",
    "revision": null
  },
  {
    "url": "css/competitions/under19/thirdparties.css.map?_t=668d589a",
    "revision": "e982cca939a114d5109b5c2f119015bc"
  },
  {
    "url": "css/competitions/under19/thirdparties.css?_t=668d589a",
    "revision": null
  },
  {
    "url": "css/competitions/under20intercontinental/base.css.map?_t=b71e0583",
    "revision": "70a0e5b187d9ba21f8e47f138ba51d11"
  },
  {
    "url": "css/competitions/under20intercontinental/base.css?_t=b71e0583",
    "revision": null
  },
  {
    "url": "css/competitions/under20intercontinental/thirdparties.css.map?_t=519ee4df",
    "revision": "e1ce0758d34cbd05bc667936d77eabee"
  },
  {
    "url": "css/competitions/under20intercontinental/thirdparties.css?_t=519ee4df",
    "revision": null
  },
  {
    "url": "css/competitions/under21/base.css.map?_t=81b080cb",
    "revision": "d816e00673494bb540b89d4f722ad99a"
  },
  {
    "url": "css/competitions/under21/base.css?_t=81b080cb",
    "revision": null
  },
  {
    "url": "css/competitions/under21/sections/event-guide.css.map?_t=0ddf5df9",
    "revision": "cb1ace9d58e00c54dd1ce26465725fac"
  },
  {
    "url": "css/competitions/under21/sections/event-guide.css?_t=0ddf5df9",
    "revision": null
  },
  {
    "url": "css/competitions/under21/sections/gott.css.map?_t=0b6de967",
    "revision": "893efdf763b28ecde256d7f9767057df"
  },
  {
    "url": "css/competitions/under21/sections/gott.css?_t=0b6de967",
    "revision": null
  },
  {
    "url": "css/competitions/under21/sections/top-scorer.css.map?_t=c489291a",
    "revision": "4c2c0a50f259c13f9b7047a70bd2a714"
  },
  {
    "url": "css/competitions/under21/sections/top-scorer.css?_t=c489291a",
    "revision": null
  },
  {
    "url": "css/competitions/under21/thirdparties.css.map?_t=4e482039",
    "revision": "9def47951fefe3f9b28012aea5fa24b7"
  },
  {
    "url": "css/competitions/under21/thirdparties.css?_t=4e482039",
    "revision": null
  },
  {
    "url": "css/competitions/womenseuro/base.css.map?_t=3cbc5fd1",
    "revision": "b62f15bcf23b978f0fe730bec550aafe"
  },
  {
    "url": "css/competitions/womenseuro/base.css?_t=3cbc5fd1",
    "revision": null
  },
  {
    "url": "css/competitions/womenseuro/sections/event-guide.css.map?_t=adc9b2d8",
    "revision": "992cc9aa57530e610491e817473a17db"
  },
  {
    "url": "css/competitions/womenseuro/sections/event-guide.css?_t=adc9b2d8",
    "revision": null
  },
  {
    "url": "css/competitions/womenseuro/thirdparties.css.map?_t=84ab2fdd",
    "revision": "fb8b0f98f596a0bf40a6a3a37450d4c7"
  },
  {
    "url": "css/competitions/womenseuro/thirdparties.css?_t=84ab2fdd",
    "revision": null
  },
  {
    "url": "css/competitions/womenseuropacup/base.css.map?_t=11326ffd",
    "revision": "b7f933d694d7b4a18074f07e1ba53cb3"
  },
  {
    "url": "css/competitions/womenseuropacup/base.css?_t=11326ffd",
    "revision": null
  },
  {
    "url": "css/competitions/womenseuropacup/thirdparties.css.map?_t=12d963b7",
    "revision": "9429e8a5f52e667eb7b8fdc8e48787d3"
  },
  {
    "url": "css/competitions/womenseuropacup/thirdparties.css?_t=12d963b7",
    "revision": null
  },
  {
    "url": "css/competitions/womenseuropeanqualifiers/base.css.map?_t=77959bf9",
    "revision": "96ae59f0b2a4d325ffa49d0ad7579b7f"
  },
  {
    "url": "css/competitions/womenseuropeanqualifiers/base.css?_t=77959bf9",
    "revision": null
  },
  {
    "url": "css/competitions/womenseuropeanqualifiers/thirdparties.css.map?_t=8b65942a",
    "revision": "54f0f82f9fff3c037414063343fa8af9"
  },
  {
    "url": "css/competitions/womenseuropeanqualifiers/thirdparties.css?_t=8b65942a",
    "revision": null
  },
  {
    "url": "css/competitions/womensfinalissima/base.css.map?_t=ca4cd5ea",
    "revision": "3150e44294d100a77e3d47cae73d6521"
  },
  {
    "url": "css/competitions/womensfinalissima/base.css?_t=ca4cd5ea",
    "revision": null
  },
  {
    "url": "css/competitions/womensfinalissima/thirdparties.css.map?_t=7fcbc544",
    "revision": "03ef3bbe4ca7605c0710832b80bb2a2f"
  },
  {
    "url": "css/competitions/womensfinalissima/thirdparties.css?_t=7fcbc544",
    "revision": null
  },
  {
    "url": "css/competitions/womensfutsaleuro/base.css.map?_t=e961d925",
    "revision": "22ab94361beea53c2bfd3d08493abf3c"
  },
  {
    "url": "css/competitions/womensfutsaleuro/base.css?_t=e961d925",
    "revision": null
  },
  {
    "url": "css/competitions/womensfutsaleuro/thirdparties.css.map?_t=a7a61fab",
    "revision": "7d26b1e23248d40a4fd1051e8d539e6f"
  },
  {
    "url": "css/competitions/womensfutsaleuro/thirdparties.css?_t=a7a61fab",
    "revision": null
  },
  {
    "url": "css/competitions/womensfutsalqualifiers/base.css.map?_t=9f21ea13",
    "revision": "58255e46e6889ea4e07d751de690287d"
  },
  {
    "url": "css/competitions/womensfutsalqualifiers/base.css?_t=9f21ea13",
    "revision": null
  },
  {
    "url": "css/competitions/womensfutsalqualifiers/thirdparties.css.map?_t=c174c417",
    "revision": "4faabe5f69b4033e1311138c2fabf3d7"
  },
  {
    "url": "css/competitions/womensfutsalqualifiers/thirdparties.css?_t=c174c417",
    "revision": null
  },
  {
    "url": "css/competitions/womensnationsleague/base.css.map?_t=93647a4b",
    "revision": "26f1365ea64e14800159cbb3378eb94c"
  },
  {
    "url": "css/competitions/womensnationsleague/base.css?_t=93647a4b",
    "revision": null
  },
  {
    "url": "css/competitions/womensnationsleague/thirdparties.css.map?_t=02f89cb6",
    "revision": "f75a6933bc7b045d9209fe70aa6cdbd2"
  },
  {
    "url": "css/competitions/womensnationsleague/thirdparties.css?_t=02f89cb6",
    "revision": null
  },
  {
    "url": "css/competitions/womensunder17/base.css.map?_t=7819e801",
    "revision": "a3489209bb798570fe8e82420e27f355"
  },
  {
    "url": "css/competitions/womensunder17/base.css?_t=7819e801",
    "revision": null
  },
  {
    "url": "css/competitions/womensunder17/thirdparties.css.map?_t=127aaae9",
    "revision": "62b929275d5ba33b368b719f3a30c8ca"
  },
  {
    "url": "css/competitions/womensunder17/thirdparties.css?_t=127aaae9",
    "revision": null
  },
  {
    "url": "css/competitions/womensunder19/base.css.map?_t=d616e87d",
    "revision": "51456495125fb235cb6048f3f653d3c0"
  },
  {
    "url": "css/competitions/womensunder19/base.css?_t=d616e87d",
    "revision": null
  },
  {
    "url": "css/competitions/womensunder19/thirdparties.css.map?_t=b3172bc1",
    "revision": "620dab737eb66778e5e7b380431f17a5"
  },
  {
    "url": "css/competitions/womensunder19/thirdparties.css?_t=b3172bc1",
    "revision": null
  },
  {
    "url": "css/competitions/womensworldcup/base.css.map?_t=634ca078",
    "revision": "d1111fba917c6f1a93e1ace9961d1555"
  },
  {
    "url": "css/competitions/womensworldcup/base.css?_t=634ca078",
    "revision": null
  },
  {
    "url": "css/competitions/womensworldcup/thirdparties.css.map?_t=513501db",
    "revision": "019d1c5aca471050e55f48ad53ed292a"
  },
  {
    "url": "css/competitions/womensworldcup/thirdparties.css?_t=513501db",
    "revision": null
  },
  {
    "url": "css/competitions/wucl/base.css.map?_t=58abbc20",
    "revision": "19565b9d48b8b84e6234157a9e3bdc13"
  },
  {
    "url": "css/competitions/wucl/base.css?_t=58abbc20",
    "revision": null
  },
  {
    "url": "css/competitions/wucl/thirdparties.css.map?_t=57a1ef8a",
    "revision": "f6e97cbcbef58fda73940a957956a73b"
  },
  {
    "url": "css/competitions/wucl/thirdparties.css?_t=57a1ef8a",
    "revision": null
  },
  {
    "url": "css/competitions/youthleague/base.css.map?_t=1e35ff35",
    "revision": "aa2a6c722623c0918ef872680844afdc"
  },
  {
    "url": "css/competitions/youthleague/base.css?_t=1e35ff35",
    "revision": null
  },
  {
    "url": "css/competitions/youthleague/thirdparties.css.map?_t=93be232a",
    "revision": "58c8b1bbdff4f222fcb458de175d0e2f"
  },
  {
    "url": "css/competitions/youthleague/thirdparties.css?_t=93be232a",
    "revision": null
  },
  {
    "url": "css/de.cf1e2836.css",
    "revision": null
  },
  {
    "url": "css/dea.cd5b1fa3.css",
    "revision": null
  },
  {
    "url": "css/e.e0894d38.css",
    "revision": null
  },
  {
    "url": "css/e1.d2f029a7.css",
    "revision": null
  },
  {
    "url": "css/e4.7402fb85.css",
    "revision": null
  },
  {
    "url": "css/ea.be795a4a.css",
    "revision": null
  },
  {
    "url": "css/eb.7bfbd081.css",
    "revision": null
  },
  {
    "url": "css/ei.ff1cc44d.css",
    "revision": null
  },
  {
    "url": "css/et.72ec0cdb.css",
    "revision": null
  },
  {
    "url": "css/fm.3efb8b03.css",
    "revision": null
  },
  {
    "url": "css/fonts/global.css.map?_t=f25ca015",
    "revision": "2a17cb89988d2f71202cb429cc864194"
  },
  {
    "url": "css/fonts/global.css?_t=f25ca015",
    "revision": null
  },
  {
    "url": "css/fs.1b4bb1f3.css",
    "revision": null
  },
  {
    "url": "css/fv.13ffb4f9.css",
    "revision": null
  },
  {
    "url": "css/fw.999acba1.css",
    "revision": null
  },
  {
    "url": "css/gl.f6501ca5.css",
    "revision": null
  },
  {
    "url": "css/h.461cd065.css",
    "revision": null
  },
  {
    "url": "css/hq.2a4522aa.css",
    "revision": null
  },
  {
    "url": "css/i.03b28b00.css",
    "revision": null
  },
  {
    "url": "css/ie.abb4761b.css",
    "revision": null
  },
  {
    "url": "css/iid.6b56efde.css",
    "revision": null
  },
  {
    "url": "css/ijf.e7fb4555.css",
    "revision": null
  },
  {
    "url": "css/io.a8a55669.css",
    "revision": null
  },
  {
    "url": "css/iu.fdfb9185.css",
    "revision": null
  },
  {
    "url": "css/jh.b3a1f339.css",
    "revision": null
  },
  {
    "url": "css/jrt.573a460d.css",
    "revision": null
  },
  {
    "url": "css/js.76dd85e8.css",
    "revision": null
  },
  {
    "url": "css/k.2581aca1.css",
    "revision": null
  },
  {
    "url": "css/k1w.a8ab498e.css",
    "revision": null
  },
  {
    "url": "css/ka.0928ff6b.css",
    "revision": null
  },
  {
    "url": "css/ka0.d52fe08d.css",
    "revision": null
  },
  {
    "url": "css/kj.c584d2d1.css",
    "revision": null
  },
  {
    "url": "css/l.1759fb22.css",
    "revision": null
  },
  {
    "url": "css/lc.04ea25be.css",
    "revision": null
  },
  {
    "url": "css/li.e94764d3.css",
    "revision": null
  },
  {
    "url": "css/ly.56d13f21.css",
    "revision": null
  },
  {
    "url": "css/m.4eac9390.css",
    "revision": null
  },
  {
    "url": "css/m3.e2b884be.css",
    "revision": null
  },
  {
    "url": "css/m4.a4f61679.css",
    "revision": null
  },
  {
    "url": "css/mb.d8eda895.css",
    "revision": null
  },
  {
    "url": "css/mn.75c5024c.css",
    "revision": null
  },
  {
    "url": "css/modules/audioplayer/audioplayer.css.map?_t=bc7fa85d",
    "revision": "b866677bc6fa4e3d35f4472553c178e6"
  },
  {
    "url": "css/modules/audioplayer/audioplayer.css?_t=bc7fa85d",
    "revision": null
  },
  {
    "url": "css/modules/common/blocks-module.css.map?_t=fd423c40",
    "revision": "c2faaf4e2d09349f590e556043f9f073"
  },
  {
    "url": "css/modules/common/blocks-module.css?_t=fd423c40",
    "revision": null
  },
  {
    "url": "css/modules/common/box-with-link.css.map?_t=ce67029e",
    "revision": "167a3d3f22e6b7178043b41994496899"
  },
  {
    "url": "css/modules/common/box-with-link.css?_t=ce67029e",
    "revision": null
  },
  {
    "url": "css/modules/common/boxed-link.css.map?_t=f19df714",
    "revision": "7ad6fe7d93e26ad4647b9dd57481c654"
  },
  {
    "url": "css/modules/common/boxed-link.css?_t=f19df714",
    "revision": null
  },
  {
    "url": "css/modules/common/carousel-preload.css.map?_t=53ce2d3a",
    "revision": "6a4a360dcf56f1590fe59ea99ca75bc4"
  },
  {
    "url": "css/modules/common/carousel-preload.css?_t=53ce2d3a",
    "revision": null
  },
  {
    "url": "css/modules/common/carousel.css.map?_t=652c6638",
    "revision": "856b8d0aae6446e36b01de29d5ff7028"
  },
  {
    "url": "css/modules/common/carousel.css?_t=652c6638",
    "revision": null
  },
  {
    "url": "css/modules/common/chipsmenu.css.map?_t=748cbfed",
    "revision": "064d5998e2a64a75e21ab3f4cbb9052f"
  },
  {
    "url": "css/modules/common/chipsmenu.css?_t=748cbfed",
    "revision": null
  },
  {
    "url": "css/modules/common/email-promo-panel.css.map?_t=3bd22ff0",
    "revision": "45dfde5995ff434f336c80fc759c2ffb"
  },
  {
    "url": "css/modules/common/email-promo-panel.css?_t=3bd22ff0",
    "revision": null
  },
  {
    "url": "css/modules/common/header-sticky.css.map?_t=2d780ffa",
    "revision": "8e2bb036ac8aeb99cd4664269a31d9b1"
  },
  {
    "url": "css/modules/common/header-sticky.css?_t=2d780ffa",
    "revision": null
  },
  {
    "url": "css/modules/common/inpage-nav.css.map?_t=9240308e",
    "revision": "ed128b86b2a13952f6b299a6609c3375"
  },
  {
    "url": "css/modules/common/inpage-nav.css?_t=9240308e",
    "revision": null
  },
  {
    "url": "css/modules/common/promo-app-panel.css.map?_t=42107ff9",
    "revision": "df7c09a283b713e17f4b82e8e18a8562"
  },
  {
    "url": "css/modules/common/promo-app-panel.css?_t=42107ff9",
    "revision": null
  },
  {
    "url": "css/modules/common/promo-generic-app-panel.css.map?_t=68820ec7",
    "revision": "99de9688ec05a81f37a9ef275a9cd1df"
  },
  {
    "url": "css/modules/common/promo-generic-app-panel.css?_t=68820ec7",
    "revision": null
  },
  {
    "url": "css/modules/common/promo-panel.css.map?_t=14efc053",
    "revision": "6fe39efd81b0a2b76e1c9a730f6a738c"
  },
  {
    "url": "css/modules/common/promo-panel.css?_t=14efc053",
    "revision": null
  },
  {
    "url": "css/modules/common/simple-box-with-icon.css.map?_t=250dfb7b",
    "revision": "945259708d6597d969179fc29e59d62b"
  },
  {
    "url": "css/modules/common/simple-box-with-icon.css?_t=250dfb7b",
    "revision": null
  },
  {
    "url": "css/modules/common/sponsored-header.css.map?_t=c407fc58",
    "revision": "d7c38153f35541ef2669ccb3766edc49"
  },
  {
    "url": "css/modules/common/sponsored-header.css?_t=c407fc58",
    "revision": null
  },
  {
    "url": "css/modules/common/uefatv-promo-panel.css.map?_t=b97a4567",
    "revision": "76cbfe391f9c92fafc07d1a2e4a1dcb6"
  },
  {
    "url": "css/modules/common/uefatv-promo-panel.css?_t=b97a4567",
    "revision": null
  },
  {
    "url": "css/modules/common/videoplayer-preload.css.map?_t=9573195e",
    "revision": "1d6e8b437bc46afb7fcff5b21643c6d5"
  },
  {
    "url": "css/modules/common/videoplayer-preload.css?_t=9573195e",
    "revision": null
  },
  {
    "url": "css/modules/common/want-to-know-more.css.map?_t=3589f258",
    "revision": "2afdd729e5adc2c066e19cb2505d2495"
  },
  {
    "url": "css/modules/common/want-to-know-more.css?_t=3589f258",
    "revision": null
  },
  {
    "url": "css/modules/comparison/h2h-module.css.map?_t=27935587",
    "revision": "ee5afea7c1cf88771c29379ebe37bc72"
  },
  {
    "url": "css/modules/comparison/h2h-module.css?_t=27935587",
    "revision": null
  },
  {
    "url": "css/modules/comparison/h2h.css.map?_t=4f5cc932",
    "revision": "0650d572b0271b3ffda5e2527dcda702"
  },
  {
    "url": "css/modules/comparison/h2h.css?_t=4f5cc932",
    "revision": null
  },
  {
    "url": "css/modules/editorial/article-header-corporate.css.map?_t=ec0ae1f0",
    "revision": "5ed636c5f11d45a927b8b01f61464d27"
  },
  {
    "url": "css/modules/editorial/article-header-corporate.css?_t=ec0ae1f0",
    "revision": null
  },
  {
    "url": "css/modules/editorial/article-header.css.map?_t=a6cebd1c",
    "revision": "35889471c35150f0fdb431e368a7c450"
  },
  {
    "url": "css/modules/editorial/article-header.css?_t=a6cebd1c",
    "revision": null
  },
  {
    "url": "css/modules/editorial/cards-list.css.map?_t=4b6ec9f4",
    "revision": "809f180ea4e8f38dfe1dad5211149925"
  },
  {
    "url": "css/modules/editorial/cards-list.css?_t=4b6ec9f4",
    "revision": null
  },
  {
    "url": "css/modules/editorial/cover-page.css.map?_t=d4f19995",
    "revision": "96ddb4d3eb98df3534b741d4f6d1db9f"
  },
  {
    "url": "css/modules/editorial/cover-page.css?_t=d4f19995",
    "revision": null
  },
  {
    "url": "css/modules/editorial/crisis.css.map?_t=f956ab82",
    "revision": "2ab19dc4f1c5b53d4efd06851cdbe120"
  },
  {
    "url": "css/modules/editorial/crisis.css?_t=f956ab82",
    "revision": null
  },
  {
    "url": "css/modules/editorial/disciplinary-updates.css.map?_t=1a3f636a",
    "revision": "7ca08e4c613165d8b85890f94c67b9ba"
  },
  {
    "url": "css/modules/editorial/disciplinary-updates.css?_t=1a3f636a",
    "revision": null
  },
  {
    "url": "css/modules/editorial/documents-lists.css.map?_t=4abdc943",
    "revision": "0bf7de5ab2cb1bc5eff23a1e4a058903"
  },
  {
    "url": "css/modules/editorial/documents-lists.css?_t=4abdc943",
    "revision": null
  },
  {
    "url": "css/modules/editorial/editorial-carousel.css.map?_t=9ef71462",
    "revision": "03ec068065e570f9bd4eaee25baa3894"
  },
  {
    "url": "css/modules/editorial/editorial-carousel.css?_t=9ef71462",
    "revision": null
  },
  {
    "url": "css/modules/editorial/editorial-compact.css.map?_t=96a3455b",
    "revision": "3d718f327c571f31337dbb0b58690d0f"
  },
  {
    "url": "css/modules/editorial/editorial-compact.css?_t=96a3455b",
    "revision": null
  },
  {
    "url": "css/modules/editorial/executive-committee.css.map?_t=c5fa0d6f",
    "revision": "d71bfdd6e622f5f6865f5d3974581289"
  },
  {
    "url": "css/modules/editorial/executive-committee.css?_t=c5fa0d6f",
    "revision": null
  },
  {
    "url": "css/modules/editorial/generic-cards.css.map?_t=9fb4f9ac",
    "revision": "2ae3c8fc4170955d4a72b87fd967a6e2"
  },
  {
    "url": "css/modules/editorial/generic-cards.css?_t=9fb4f9ac",
    "revision": null
  },
  {
    "url": "css/modules/editorial/header-xl.css.map?_t=03fa6dfb",
    "revision": "50c83a35759a7e9b95a4842b0c72e411"
  },
  {
    "url": "css/modules/editorial/header-xl.css?_t=03fa6dfb",
    "revision": null
  },
  {
    "url": "css/modules/editorial/hero-experience-preload.css.map?_t=27328402",
    "revision": "266cd489bfa3984cf02dcbcfa7eca827"
  },
  {
    "url": "css/modules/editorial/hero-experience-preload.css?_t=27328402",
    "revision": null
  },
  {
    "url": "css/modules/editorial/hero-experience.css.map?_t=245a26db",
    "revision": "85b86b727c245551a2f08922d7b4dc2f"
  },
  {
    "url": "css/modules/editorial/hero-experience.css?_t=245a26db",
    "revision": null
  },
  {
    "url": "css/modules/editorial/mosaic-preload.css.map?_t=d547b4f9",
    "revision": "c296ea70d8d0bfefd37be11c16bb7796"
  },
  {
    "url": "css/modules/editorial/mosaic-preload.css?_t=d547b4f9",
    "revision": null
  },
  {
    "url": "css/modules/editorial/newsletter-subscription.css.map?_t=5fe253da",
    "revision": "3a461fd417e5b04853778ec7c62634f7"
  },
  {
    "url": "css/modules/editorial/newsletter-subscription.css?_t=5fe253da",
    "revision": null
  },
  {
    "url": "css/modules/editorial/podcast-list.css.map?_t=b6b191ce",
    "revision": "a37812d795b9049629a10716d6abdc55"
  },
  {
    "url": "css/modules/editorial/podcast-list.css?_t=b6b191ce",
    "revision": null
  },
  {
    "url": "css/modules/editorial/today-preload.css.map?_t=84893883",
    "revision": "2ebf964881a795ad84f0c101fddacd0d"
  },
  {
    "url": "css/modules/editorial/today-preload.css?_t=84893883",
    "revision": null
  },
  {
    "url": "css/modules/editorial/today.css.map?_t=14ed9ee8",
    "revision": "b6aa76ffe60cbf15627c4644f3e1d4e5"
  },
  {
    "url": "css/modules/editorial/today.css?_t=14ed9ee8",
    "revision": null
  },
  {
    "url": "css/modules/editorial/uefatv-preload.css.map?_t=21562809",
    "revision": "95f1359428c0f3ad79e5095f5bc5702b"
  },
  {
    "url": "css/modules/editorial/uefatv-preload.css?_t=21562809",
    "revision": null
  },
  {
    "url": "css/modules/editorial/webcontainer-carousel.css.map?_t=aae6a349",
    "revision": "9c16289d30ef920a52c157d34a33db05"
  },
  {
    "url": "css/modules/editorial/webcontainer-carousel.css?_t=aae6a349",
    "revision": null
  },
  {
    "url": "css/modules/error/errors.css.map?_t=f90ffb36",
    "revision": "7e963a2a1870c4824286428873a84c8a"
  },
  {
    "url": "css/modules/error/errors.css?_t=f90ffb36",
    "revision": null
  },
  {
    "url": "css/modules/event-guide/landing-tickets-companion.css.map?_t=5962e414",
    "revision": "6580ca4956d5078e4b04a9aa0d9544e3"
  },
  {
    "url": "css/modules/event-guide/landing-tickets-companion.css?_t=5962e414",
    "revision": null
  },
  {
    "url": "css/modules/event-guide/mobile-app-box.css.map?_t=273aab4d",
    "revision": "eb55d116360f8d1fd6f144bf271544f0"
  },
  {
    "url": "css/modules/event-guide/mobile-app-box.css?_t=273aab4d",
    "revision": null
  },
  {
    "url": "css/modules/footballdata/coefficient-rankings.css.map?_t=4c356629",
    "revision": "fedd354ae1b5e7904fbc435c32d5f5bb"
  },
  {
    "url": "css/modules/footballdata/coefficient-rankings.css?_t=4c356629",
    "revision": null
  },
  {
    "url": "css/modules/footballdata/coefficients-preload.css.map?_t=69e784e5",
    "revision": "4541ab97f15acfc5f238aeeadecebd02"
  },
  {
    "url": "css/modules/footballdata/coefficients-preload.css?_t=69e784e5",
    "revision": null
  },
  {
    "url": "css/modules/footballdata/football-rail-preload.css.map?_t=ca2c4344",
    "revision": "56702e7571dda2410a3367977a51a488"
  },
  {
    "url": "css/modules/footballdata/football-rail-preload.css?_t=ca2c4344",
    "revision": null
  },
  {
    "url": "css/modules/footballdata/hp-stats.css.map?_t=cd05ba3e",
    "revision": "1bdc62bc85422a85c784bb2bbd3604cf"
  },
  {
    "url": "css/modules/footballdata/hp-stats.css?_t=cd05ba3e",
    "revision": null
  },
  {
    "url": "css/modules/footballdata/standings.css.map?_t=c245a49f",
    "revision": "c578743d69d54a254f33e963b1cddae0"
  },
  {
    "url": "css/modules/footballdata/standings.css?_t=c245a49f",
    "revision": null
  },
  {
    "url": "css/modules/gott/swiper.css.map?_t=e8fb8e38",
    "revision": "5a2c3d9d1ff3321b0a281fbf593b396c"
  },
  {
    "url": "css/modules/gott/swiper.css?_t=e8fb8e38",
    "revision": null
  },
  {
    "url": "css/modules/history/club-matches-played.css.map?_t=4a9fe4f9",
    "revision": "3597bbfac13ee4f170132e52c20f4337"
  },
  {
    "url": "css/modules/history/club-matches-played.css?_t=4a9fe4f9",
    "revision": null
  },
  {
    "url": "css/modules/history/winners.css.map?_t=cb2b4433",
    "revision": "5dc3c05aad5a4b1a49f92022d794d3ff"
  },
  {
    "url": "css/modules/history/winners.css?_t=cb2b4433",
    "revision": null
  },
  {
    "url": "css/modules/interceptor/interceptor-full.css.map?_t=12efe3c8",
    "revision": "d4f2378160cf2cb4ecd6956f78de098d"
  },
  {
    "url": "css/modules/interceptor/interceptor-full.css?_t=12efe3c8",
    "revision": null
  },
  {
    "url": "css/modules/jobs/jobslist.css.map?_t=58c91482",
    "revision": "f421ce0e6b6865eadae6e6d3a7e21473"
  },
  {
    "url": "css/modules/jobs/jobslist.css?_t=58c91482",
    "revision": null
  },
  {
    "url": "css/modules/jobs/opportunities-banner.css.map?_t=99c15625",
    "revision": "9d0300d6ddf7e141355d7529e81a4a0c"
  },
  {
    "url": "css/modules/jobs/opportunities-banner.css?_t=99c15625",
    "revision": null
  },
  {
    "url": "css/modules/liveblog/liveblog-preload.css.map?_t=56b5b362",
    "revision": "91b1c75e91d5251582eebec6fa0317c5"
  },
  {
    "url": "css/modules/liveblog/liveblog-preload.css?_t=56b5b362",
    "revision": null
  },
  {
    "url": "css/modules/liveblog/liveblog.css.map?_t=d166d590",
    "revision": "ceab0526f06c161e8920fc34dca27fb6"
  },
  {
    "url": "css/modules/liveblog/liveblog.css?_t=d166d590",
    "revision": null
  },
  {
    "url": "css/modules/match-units/boxed.css.map?_t=d24c97c3",
    "revision": "4714eaa05a63f8f12a4b1eed1de54954"
  },
  {
    "url": "css/modules/match-units/boxed.css?_t=d24c97c3",
    "revision": null
  },
  {
    "url": "css/modules/match-units/horizontal.css.map?_t=6fa82f40",
    "revision": "3232cc6a17c949c7d0136841dad735e4"
  },
  {
    "url": "css/modules/match-units/horizontal.css?_t=6fa82f40",
    "revision": null
  },
  {
    "url": "css/modules/match-units/vertical.css.map?_t=da9c7847",
    "revision": "0c64e694fceb65ffb1db730188f78027"
  },
  {
    "url": "css/modules/match-units/vertical.css?_t=da9c7847",
    "revision": null
  },
  {
    "url": "css/modules/matches/boxed-list.css.map?_t=fd18245d",
    "revision": "8ee97daa4e6115727af5ca00b4bec843"
  },
  {
    "url": "css/modules/matches/boxed-list.css?_t=fd18245d",
    "revision": null
  },
  {
    "url": "css/modules/matches/match-info.css.map?_t=4528b937",
    "revision": "8bca05303ff2aae6e29778428e94e413"
  },
  {
    "url": "css/modules/matches/match-info.css?_t=4528b937",
    "revision": null
  },
  {
    "url": "css/modules/matches/match-strip.css.map?_t=d42af9f1",
    "revision": "77e41fdb5cc3ac07800e0528992e8c0a"
  },
  {
    "url": "css/modules/matches/match-strip.css?_t=d42af9f1",
    "revision": null
  },
  {
    "url": "css/modules/matches/match-timeline-preload.css.map?_t=955594cc",
    "revision": "988c5a44f990b2db8c7fe1226f835c15"
  },
  {
    "url": "css/modules/matches/match-timeline-preload.css?_t=955594cc",
    "revision": null
  },
  {
    "url": "css/modules/matches/matchday-live.css.map?_t=dd35598e",
    "revision": "1753a0c5cb2507bc3ee05fcab8cb5b62"
  },
  {
    "url": "css/modules/matches/matchday-live.css?_t=dd35598e",
    "revision": null
  },
  {
    "url": "css/modules/matches/press-kits.css.map?_t=30b567e8",
    "revision": "0614915781686251269cb7d1e939df5d"
  },
  {
    "url": "css/modules/matches/press-kits.css?_t=30b567e8",
    "revision": null
  },
  {
    "url": "css/modules/players/header.css.map?_t=fef2c242",
    "revision": "0690f77fe22697248d3bb9d252857a0e"
  },
  {
    "url": "css/modules/players/header.css?_t=fef2c242",
    "revision": null
  },
  {
    "url": "css/modules/players/profile.css.map?_t=eccf2c9c",
    "revision": "9d84bf95bc9e04e3687dee7dfe28accb"
  },
  {
    "url": "css/modules/players/profile.css?_t=eccf2c9c",
    "revision": null
  },
  {
    "url": "css/modules/promo/generic-banner.css.map?_t=3d129e0a",
    "revision": "e955725909b78b06bb4739799467c865"
  },
  {
    "url": "css/modules/promo/generic-banner.css?_t=3d129e0a",
    "revision": null
  },
  {
    "url": "css/modules/statistics/all-time.css.map?_t=8a4a60bc",
    "revision": "b79d1ef5e4d6b98e2ea55dbb8e3d1f7f"
  },
  {
    "url": "css/modules/statistics/all-time.css?_t=8a4a60bc",
    "revision": null
  },
  {
    "url": "css/modules/statistics/career.css.map?_t=83103f95",
    "revision": "5f7d142677c79d5d17d62474f133b45f"
  },
  {
    "url": "css/modules/statistics/career.css?_t=83103f95",
    "revision": null
  },
  {
    "url": "css/modules/statistics/honours.css.map?_t=ad277600",
    "revision": "e498ba9a414a90dd39514866f10724d2"
  },
  {
    "url": "css/modules/statistics/honours.css?_t=ad277600",
    "revision": null
  },
  {
    "url": "css/modules/statistics/last-seasons.css.map?_t=fa918e79",
    "revision": "c326ab07b173f564062a9e7bdb589f60"
  },
  {
    "url": "css/modules/statistics/last-seasons.css?_t=fa918e79",
    "revision": null
  },
  {
    "url": "css/modules/statistics/rankings-navigation.css.map?_t=13f41804",
    "revision": "3a142bc8c2ef922c8a6d04967cad3419"
  },
  {
    "url": "css/modules/statistics/rankings-navigation.css?_t=13f41804",
    "revision": null
  },
  {
    "url": "css/modules/statistics/seasons_stats.css.map?_t=3bf125ce",
    "revision": "c8ccffe1f1f713d53cd74ffaabe138d2"
  },
  {
    "url": "css/modules/statistics/seasons_stats.css?_t=3bf125ce",
    "revision": null
  },
  {
    "url": "css/modules/statistics/statistics-module.css.map?_t=a6c8a30c",
    "revision": "5b4fb54e20f2deb37582143cb6c8cbd4"
  },
  {
    "url": "css/modules/statistics/statistics-module.css?_t=a6c8a30c",
    "revision": null
  },
  {
    "url": "css/modules/teams/association-header.css.map?_t=7f3cd43e",
    "revision": "5bb9ec30854f3f6d1a08fd5ae29d0efa"
  },
  {
    "url": "css/modules/teams/association-header.css?_t=7f3cd43e",
    "revision": null
  },
  {
    "url": "css/modules/teams/matches.css.map?_t=3435dddf",
    "revision": "a01e75d8ed7365eefd0f686aab98fa4c"
  },
  {
    "url": "css/modules/teams/matches.css?_t=3435dddf",
    "revision": null
  },
  {
    "url": "css/modules/teams/na-teams-overview.css.map?_t=d48bbe73",
    "revision": "b466a3a2c18c137f4d41aed1293ce316"
  },
  {
    "url": "css/modules/teams/na-teams-overview.css?_t=d48bbe73",
    "revision": null
  },
  {
    "url": "css/modules/teams/national-teams.css.map?_t=4158ebea",
    "revision": "01ee26faa4a1b38e82deaa019cb667c4"
  },
  {
    "url": "css/modules/teams/national-teams.css?_t=4158ebea",
    "revision": null
  },
  {
    "url": "css/modules/teams/squad-carousel.css.map?_t=a8d68ec4",
    "revision": "87a6d15c920fde1bfa74475bd24fbabd"
  },
  {
    "url": "css/modules/teams/squad-carousel.css?_t=a8d68ec4",
    "revision": null
  },
  {
    "url": "css/modules/teams/squadlist.css.map?_t=22fb6ee1",
    "revision": "d2b3a37311cd5d064fd0ea736232a0ab"
  },
  {
    "url": "css/modules/teams/squadlist.css?_t=22fb6ee1",
    "revision": null
  },
  {
    "url": "css/modules/teams/teams-overview.css.map?_t=10d827bc",
    "revision": "386f0058f36c1f916ddc2c2cdfa66cba"
  },
  {
    "url": "css/modules/teams/teams-overview.css?_t=10d827bc",
    "revision": null
  },
  {
    "url": "css/modules/template/footer-corporate.css.map?_t=f057d311",
    "revision": "4bc0a77436592d12bd50123a28f30a28"
  },
  {
    "url": "css/modules/template/footer-corporate.css?_t=f057d311",
    "revision": null
  },
  {
    "url": "css/modules/template/footer-uc3.css.map?_t=fb90c7c8",
    "revision": "d7694a1ba558da0beb7c696fa313de23"
  },
  {
    "url": "css/modules/template/footer-uc3.css?_t=fb90c7c8",
    "revision": null
  },
  {
    "url": "css/modules/template/footer.css.map?_t=235639f7",
    "revision": "c9a6f5b5bcfbe1f0c3b4fa0bd8461f62"
  },
  {
    "url": "css/modules/template/footer.css?_t=235639f7",
    "revision": null
  },
  {
    "url": "css/modules/template/header-preload.css.map?_t=77f463db",
    "revision": "d8a1873b08e545fbf0547f160541c51f"
  },
  {
    "url": "css/modules/template/header-preload.css?_t=77f463db",
    "revision": null
  },
  {
    "url": "css/modules/template/segmented-control-menu.css.map?_t=3e8f0f70",
    "revision": "fd76bfa094193e189d037f30c7b7fabc"
  },
  {
    "url": "css/modules/template/segmented-control-menu.css?_t=3e8f0f70",
    "revision": null
  },
  {
    "url": "css/modules/template/sticky-nav-preload.css.map?_t=a09f8465",
    "revision": "65ab971562481a6a59a1665dd666fca8"
  },
  {
    "url": "css/modules/template/sticky-nav-preload.css?_t=a09f8465",
    "revision": null
  },
  {
    "url": "css/modules/template/tabsmenu.css.map?_t=85bcbae3",
    "revision": "6547734fd6232db8ac8dd059e2f80cf3"
  },
  {
    "url": "css/modules/template/tabsmenu.css?_t=85bcbae3",
    "revision": null
  },
  {
    "url": "css/n.b3762fe4.css",
    "revision": null
  },
  {
    "url": "css/n1.15ac6149.css",
    "revision": null
  },
  {
    "url": "css/n8.e154d08b.css",
    "revision": null
  },
  {
    "url": "css/nd.ebe056d7.css",
    "revision": null
  },
  {
    "url": "css/nl.e6e893f1.css",
    "revision": null
  },
  {
    "url": "css/o0.1066b340.css",
    "revision": null
  },
  {
    "url": "css/o5.b8987e5b.css",
    "revision": null
  },
  {
    "url": "css/o7.cb1ba878.css",
    "revision": null
  },
  {
    "url": "css/ob.64ca99b6.css",
    "revision": null
  },
  {
    "url": "css/oc.f7a38ad8.css",
    "revision": null
  },
  {
    "url": "css/od.ac108499.css",
    "revision": null
  },
  {
    "url": "css/p0.007e2b8d.css",
    "revision": null
  },
  {
    "url": "css/pc.3274d1e9.css",
    "revision": null
  },
  {
    "url": "css/ph.950c6f46.css",
    "revision": null
  },
  {
    "url": "css/pp.d5d7a90a.css",
    "revision": null
  },
  {
    "url": "css/pq.931e9458.css",
    "revision": null
  },
  {
    "url": "css/pr.57a6c90d.css",
    "revision": null
  },
  {
    "url": "css/preload.css.map?_t=ee58e234",
    "revision": "e583024d22a63916e7ab0f072e1f13dd"
  },
  {
    "url": "css/preload.css?_t=ee58e234",
    "revision": null
  },
  {
    "url": "css/px.d7f12caf.css",
    "revision": null
  },
  {
    "url": "css/q.18aa85a0.css",
    "revision": null
  },
  {
    "url": "css/q1.049e6011.css",
    "revision": null
  },
  {
    "url": "css/qa.2b9f9c7d.css",
    "revision": null
  },
  {
    "url": "css/qc.5a8961ef.css",
    "revision": null
  },
  {
    "url": "css/qn.bc6f5840.css",
    "revision": null
  },
  {
    "url": "css/rr.90fc0a53.css",
    "revision": null
  },
  {
    "url": "css/ry.e4399002.css",
    "revision": null
  },
  {
    "url": "css/sb.8ab126c3.css",
    "revision": null
  },
  {
    "url": "css/scz.07925e0d.css",
    "revision": null
  },
  {
    "url": "css/sections/article-boxed.css.map?_t=7113a252",
    "revision": "6584bc36aa4d2db37b7c65e6111da863"
  },
  {
    "url": "css/sections/article-boxed.css?_t=7113a252",
    "revision": null
  },
  {
    "url": "css/sections/article-card.css.map?_t=a7f55f4e",
    "revision": "4713116236036369cc7db98ae3b70844"
  },
  {
    "url": "css/sections/article-card.css?_t=a7f55f4e",
    "revision": null
  },
  {
    "url": "css/sections/article-corporate.css.map?_t=9cb48bc2",
    "revision": "fbd1ddc6664170e4a13376b1bfc63a4e"
  },
  {
    "url": "css/sections/article-corporate.css?_t=9cb48bc2",
    "revision": null
  },
  {
    "url": "css/sections/article-preload.css.map?_t=9ec2a269",
    "revision": "3da9073f993f71130e7c244b47cff4cf"
  },
  {
    "url": "css/sections/article-preload.css?_t=9ec2a269",
    "revision": null
  },
  {
    "url": "css/sections/article.css.map?_t=dc5be62a",
    "revision": "42a734edd0406ae8c4c14657a7fc2d71"
  },
  {
    "url": "css/sections/article.css?_t=dc5be62a",
    "revision": null
  },
  {
    "url": "css/sections/audio-description.css.map?_t=01663451",
    "revision": "bb6a68beb920f841c3c45b59df003043"
  },
  {
    "url": "css/sections/audio-description.css?_t=01663451",
    "revision": null
  },
  {
    "url": "css/sections/calendar-preload.css.map?_t=d3f4e5f0",
    "revision": "ada1b298edc3b9d62da65413500fceee"
  },
  {
    "url": "css/sections/calendar-preload.css?_t=d3f4e5f0",
    "revision": null
  },
  {
    "url": "css/sections/draw-preload.css.map?_t=29692f35",
    "revision": "4ca43181347e9991c5d9d5b09af002b5"
  },
  {
    "url": "css/sections/draw-preload.css?_t=29692f35",
    "revision": null
  },
  {
    "url": "css/sections/draw.css.map?_t=ddcb705d",
    "revision": "0ec789bc3444a7d0e017e24789081bd7"
  },
  {
    "url": "css/sections/draw.css?_t=ddcb705d",
    "revision": null
  },
  {
    "url": "css/sections/event-guide.css.map?_t=529e010d",
    "revision": "66b8330ef528ede911b889617a3a3b40"
  },
  {
    "url": "css/sections/event-guide.css?_t=529e010d",
    "revision": null
  },
  {
    "url": "css/sections/history.css.map?_t=45e197ee",
    "revision": "f7e0e73cd4c45858bec637e208dd0150"
  },
  {
    "url": "css/sections/history.css?_t=45e197ee",
    "revision": null
  },
  {
    "url": "css/sections/hospitality.css.map?_t=dbca5a01",
    "revision": "5194a0f457940d5292a3b3aab25ab52b"
  },
  {
    "url": "css/sections/hospitality.css?_t=dbca5a01",
    "revision": null
  },
  {
    "url": "css/sections/hp-comp-preload.css.map?_t=e40cd5ac",
    "revision": "7a404ba5fd50b7c06661dd3d43b24659"
  },
  {
    "url": "css/sections/hp-comp-preload.css?_t=e40cd5ac",
    "revision": null
  },
  {
    "url": "css/sections/match-page-preload.css.map?_t=0060fcae",
    "revision": "36241765c1f78e862561db330aa1eb9d"
  },
  {
    "url": "css/sections/match-page-preload.css?_t=0060fcae",
    "revision": null
  },
  {
    "url": "css/sections/match-page.css.map?_t=3f882869",
    "revision": "0aa720fe8f3bf3327b0abe5c432a3f17"
  },
  {
    "url": "css/sections/match-page.css?_t=3f882869",
    "revision": null
  },
  {
    "url": "css/sections/playgames-preload.css.map?_t=1d3102fb",
    "revision": "8d4b20a149f6e38378aa865df3b9c9dd"
  },
  {
    "url": "css/sections/playgames-preload.css?_t=1d3102fb",
    "revision": null
  },
  {
    "url": "css/sections/playmakers2-preload.css.map?_t=fc5f4606",
    "revision": "9af06366b5788a88fa5ad624b983e394"
  },
  {
    "url": "css/sections/playmakers2-preload.css?_t=fc5f4606",
    "revision": null
  },
  {
    "url": "css/sections/policies.css.map?_t=5f391f29",
    "revision": "e8767ac5371c64a0e1a797627ffb38db"
  },
  {
    "url": "css/sections/policies.css?_t=5f391f29",
    "revision": null
  },
  {
    "url": "css/sections/statistics-preload.css.map?_t=9fa7b5ce",
    "revision": "c176a07d2ab3ef51ff6c474b4bcb52b6"
  },
  {
    "url": "css/sections/statistics-preload.css?_t=9fa7b5ce",
    "revision": null
  },
  {
    "url": "css/sections/statistics.css.map?_t=a599a55d",
    "revision": "a82ff4f57dabd9964260a623b09cade4"
  },
  {
    "url": "css/sections/statistics.css?_t=a599a55d",
    "revision": null
  },
  {
    "url": "css/sections/team-section-preload.css.map?_t=9a0d3656",
    "revision": "032d32df4085a3436b0de39268b54c8c"
  },
  {
    "url": "css/sections/team-section-preload.css?_t=9a0d3656",
    "revision": null
  },
  {
    "url": "css/sections/team.css.map?_t=d113293e",
    "revision": "6f98d6b47f1ee1e639ee8bb5d2487cba"
  },
  {
    "url": "css/sections/team.css?_t=d113293e",
    "revision": null
  },
  {
    "url": "css/sections/ticketing-preload.css.map?_t=a5de4cad",
    "revision": "860b3045d234aa0c723b9001d0d17777"
  },
  {
    "url": "css/sections/ticketing-preload.css?_t=a5de4cad",
    "revision": null
  },
  {
    "url": "css/sections/tickets.css.map?_t=55d4634e",
    "revision": "67a165227059b8d175b153cd009b6ee1"
  },
  {
    "url": "css/sections/tickets.css?_t=55d4634e",
    "revision": null
  },
  {
    "url": "css/sections/top-scorer-preload.css.map?_t=7b3dd377",
    "revision": "2296a0c351be6fd918b7774bb7642654"
  },
  {
    "url": "css/sections/top-scorer-preload.css?_t=7b3dd377",
    "revision": null
  },
  {
    "url": "css/sections/top-scorer.css.map?_t=27df73b7",
    "revision": "a02edaac5a2d303996abf85405149ee0"
  },
  {
    "url": "css/sections/top-scorer.css?_t=27df73b7",
    "revision": null
  },
  {
    "url": "css/sections/uefatv.css.map?_t=4e19705a",
    "revision": "b527d17756c80239baa360af6da996e5"
  },
  {
    "url": "css/sections/uefatv.css?_t=4e19705a",
    "revision": null
  },
  {
    "url": "css/sl.8a4e50f0.css",
    "revision": null
  },
  {
    "url": "css/sz.db413f3d.css",
    "revision": null
  },
  {
    "url": "css/szy.5deeea8a.css",
    "revision": null
  },
  {
    "url": "css/thd.ef46db37.css",
    "revision": null
  },
  {
    "url": "css/thirdparties-preload.css.map?_t=6aeb3603",
    "revision": "961ec3d567ce0654853e5921e340eab4"
  },
  {
    "url": "css/thirdparties-preload.css?_t=6aeb3603",
    "revision": null
  },
  {
    "url": "css/thirdparties.css.map?_t=c19ac7e3",
    "revision": "bd08dfc64cd66cd52db8aeb1097d7cba"
  },
  {
    "url": "css/thirdparties.css?_t=c19ac7e3",
    "revision": null
  },
  {
    "url": "css/tl.51b191ff.css",
    "revision": null
  },
  {
    "url": "css/tu.9d2a79eb.css",
    "revision": null
  },
  {
    "url": "css/ty.d93a509e.css",
    "revision": null
  },
  {
    "url": "css/u.496c0ee2.css",
    "revision": null
  },
  {
    "url": "css/u4.8fec1f4a.css",
    "revision": null
  },
  {
    "url": "css/ucn.d4f26692.css",
    "revision": null
  },
  {
    "url": "css/uln.6ec7c35e.css",
    "revision": null
  },
  {
    "url": "css/ur.c4fdac57.css",
    "revision": null
  },
  {
    "url": "css/uw.bfcd5363.css",
    "revision": null
  },
  {
    "url": "css/v.308b5ad7.css",
    "revision": null
  },
  {
    "url": "css/vb.5f7e68b9.css",
    "revision": null
  },
  {
    "url": "css/vd.e62ee376.css",
    "revision": null
  },
  {
    "url": "css/vda.3da229a9.css",
    "revision": null
  },
  {
    "url": "css/vh.a0491890.css",
    "revision": null
  },
  {
    "url": "css/vl.33e50baf.css",
    "revision": null
  },
  {
    "url": "css/vm.9120188b.css",
    "revision": null
  },
  {
    "url": "css/vnc.74b98846.css",
    "revision": null
  },
  {
    "url": "css/void.css?_t=ef46db37",
    "revision": null
  },
  {
    "url": "css/x.6cd6b666.css",
    "revision": null
  },
  {
    "url": "css/y.c84ecace.css",
    "revision": null
  },
  {
    "url": "css/y3.ea07e9ef.css",
    "revision": null
  },
  {
    "url": "css/yp.e664acae.css",
    "revision": null
  },
  {
    "url": "css/yz.1258211a.css",
    "revision": null
  },
  {
    "url": "css/zm.63ad4b95.css",
    "revision": null
  },
  {
    "url": "css/zo.e38d627c.css",
    "revision": null
  },
  {
    "url": "js/0.5585fda0.js",
    "revision": null
  },
  {
    "url": "js/02.bce0467b.js",
    "revision": null
  },
  {
    "url": "js/03.632e8b18.js",
    "revision": null
  },
  {
    "url": "js/08.d2c915cc.js",
    "revision": null
  },
  {
    "url": "js/0b.a5f1381a.js",
    "revision": null
  },
  {
    "url": "js/0l.29100078.js",
    "revision": null
  },
  {
    "url": "js/0p.61e84bdb.js",
    "revision": null
  },
  {
    "url": "js/0t.faf32a4a.js",
    "revision": null
  },
  {
    "url": "js/0v.18d1f021.js",
    "revision": null
  },
  {
    "url": "js/0w.21b61a6e.js",
    "revision": null
  },
  {
    "url": "js/0wa.aa391989.js",
    "revision": null
  },
  {
    "url": "js/1.f990cd22.js",
    "revision": null
  },
  {
    "url": "js/18.fa5f49bb.js",
    "revision": null
  },
  {
    "url": "js/1a.2a43faec.js",
    "revision": null
  },
  {
    "url": "js/1f.b237413d.js",
    "revision": null
  },
  {
    "url": "js/1j.d03cd0c3.js",
    "revision": null
  },
  {
    "url": "js/1o.1b33d4e0.js",
    "revision": null
  },
  {
    "url": "js/1ou.34809143.js",
    "revision": null
  },
  {
    "url": "js/1p.11f90506.js",
    "revision": null
  },
  {
    "url": "js/1r.57723ead.js",
    "revision": null
  },
  {
    "url": "js/1z.96c351ef.js",
    "revision": null
  },
  {
    "url": "js/2.3cf4873a.js",
    "revision": null
  },
  {
    "url": "js/20.6f2b7aa7.js",
    "revision": null
  },
  {
    "url": "js/2a.c81e1c6b.js",
    "revision": null
  },
  {
    "url": "js/2f.08bcf9cb.js",
    "revision": null
  },
  {
    "url": "js/2g.328db6d7.js",
    "revision": null
  },
  {
    "url": "js/2i.65fb1380.js",
    "revision": null
  },
  {
    "url": "js/2o.282a9423.js",
    "revision": null
  },
  {
    "url": "js/2q.9e6f7abd.js",
    "revision": null
  },
  {
    "url": "js/2qa.46a32524.js",
    "revision": null
  },
  {
    "url": "js/2x.e15047e0.js",
    "revision": null
  },
  {
    "url": "js/2z.a8baf7fc.js",
    "revision": null
  },
  {
    "url": "js/3.09ca8fc2.js",
    "revision": null
  },
  {
    "url": "js/30.3ffa3fa9.js",
    "revision": null
  },
  {
    "url": "js/31.99321e5e.js",
    "revision": null
  },
  {
    "url": "js/3a.1301ace4.js",
    "revision": null
  },
  {
    "url": "js/3f.b7876860.js",
    "revision": null
  },
  {
    "url": "js/3g.aec58b4c.js",
    "revision": null
  },
  {
    "url": "js/3h.7312a1f9.js",
    "revision": null
  },
  {
    "url": "js/3j.f67ce589.js",
    "revision": null
  },
  {
    "url": "js/3m.2bb60910.js",
    "revision": null
  },
  {
    "url": "js/3m1.ef92a676.js",
    "revision": null
  },
  {
    "url": "js/3p.9398b6f1.js",
    "revision": null
  },
  {
    "url": "js/3t.4e1ea22b.js",
    "revision": null
  },
  {
    "url": "js/3v.e8430823.js",
    "revision": null
  },
  {
    "url": "js/3w.dcd52815.js",
    "revision": null
  },
  {
    "url": "js/4.e49aa520.js",
    "revision": null
  },
  {
    "url": "js/42.c24950cd.js",
    "revision": null
  },
  {
    "url": "js/47.0aea7936.js",
    "revision": null
  },
  {
    "url": "js/4b.bb19eba3.js",
    "revision": null
  },
  {
    "url": "js/4bf.ac56616d.js",
    "revision": null
  },
  {
    "url": "js/4e.d30b159f.js",
    "revision": null
  },
  {
    "url": "js/4l.28f56427.js",
    "revision": null
  },
  {
    "url": "js/4n.a70efd38.js",
    "revision": null
  },
  {
    "url": "js/4u.987c7dc8.js",
    "revision": null
  },
  {
    "url": "js/4v.c46217db.js",
    "revision": null
  },
  {
    "url": "js/5.c3904d6b.js",
    "revision": null
  },
  {
    "url": "js/50.e87bf74a.js",
    "revision": null
  },
  {
    "url": "js/54.65aabd59.js",
    "revision": null
  },
  {
    "url": "js/59.d216ed1a.js",
    "revision": null
  },
  {
    "url": "js/5b.78f23cde.js",
    "revision": null
  },
  {
    "url": "js/5n.6ea62a01.js",
    "revision": null
  },
  {
    "url": "js/5q.ffced83c.js",
    "revision": null
  },
  {
    "url": "js/5qt.99061785.js",
    "revision": null
  },
  {
    "url": "js/5r.6ba6e72e.js",
    "revision": null
  },
  {
    "url": "js/5rf.373bba48.js",
    "revision": null
  },
  {
    "url": "js/5s.79fb1b18.js",
    "revision": null
  },
  {
    "url": "js/5y.ebc67dd5.js",
    "revision": null
  },
  {
    "url": "js/5z.53162cfd.js",
    "revision": null
  },
  {
    "url": "js/6.532b342c.js",
    "revision": null
  },
  {
    "url": "js/67.7ba38bb3.js",
    "revision": null
  },
  {
    "url": "js/68.69472765.js",
    "revision": null
  },
  {
    "url": "js/6k.d8d4861f.js",
    "revision": null
  },
  {
    "url": "js/6l.61dc606b.js",
    "revision": null
  },
  {
    "url": "js/6m.e282446a.js",
    "revision": null
  },
  {
    "url": "js/6r.84fada67.js",
    "revision": null
  },
  {
    "url": "js/6ro.393097b6.js",
    "revision": null
  },
  {
    "url": "js/7.77c71947.js",
    "revision": null
  },
  {
    "url": "js/71.49d345ca.js",
    "revision": null
  },
  {
    "url": "js/72.d6bf6a5a.js",
    "revision": null
  },
  {
    "url": "js/72u.8ec63582.js",
    "revision": null
  },
  {
    "url": "js/76.37b0708a.js",
    "revision": null
  },
  {
    "url": "js/7c.c4463baf.js",
    "revision": null
  },
  {
    "url": "js/7d.6e41f6bb.js",
    "revision": null
  },
  {
    "url": "js/7n.15eba028.js",
    "revision": null
  },
  {
    "url": "js/7n2.9ca2aa19.js",
    "revision": null
  },
  {
    "url": "js/7o.e51ffa58.js",
    "revision": null
  },
  {
    "url": "js/7p.79763383.js",
    "revision": null
  },
  {
    "url": "js/7pu.d57c8cb7.js",
    "revision": null
  },
  {
    "url": "js/7q.80656f7a.js",
    "revision": null
  },
  {
    "url": "js/7r.271bfca4.js",
    "revision": null
  },
  {
    "url": "js/7t.a44fed96.js",
    "revision": null
  },
  {
    "url": "js/8.0afbce88.js",
    "revision": null
  },
  {
    "url": "js/80.af2d759f.js",
    "revision": null
  },
  {
    "url": "js/8f.50cf0c5e.js",
    "revision": null
  },
  {
    "url": "js/8j.55f33016.js",
    "revision": null
  },
  {
    "url": "js/8m.bb8b4db7.js",
    "revision": null
  },
  {
    "url": "js/8mr.22ce11e8.js",
    "revision": null
  },
  {
    "url": "js/8r.89e91b5d.js",
    "revision": null
  },
  {
    "url": "js/8rb.1f5c2210.js",
    "revision": null
  },
  {
    "url": "js/8rj.3f370ba5.js",
    "revision": null
  },
  {
    "url": "js/8t.d41d8bac.js",
    "revision": null
  },
  {
    "url": "js/8u.06c42a25.js",
    "revision": null
  },
  {
    "url": "js/8x.6fefdd1f.js",
    "revision": null
  },
  {
    "url": "js/9.839c0530.js",
    "revision": null
  },
  {
    "url": "js/92.eb4ac787.js",
    "revision": null
  },
  {
    "url": "js/9b.2628af24.js",
    "revision": null
  },
  {
    "url": "js/9e.2ba017f5.js",
    "revision": null
  },
  {
    "url": "js/9e2.5a5cdd75.js",
    "revision": null
  },
  {
    "url": "js/9m.97098fec.js",
    "revision": null
  },
  {
    "url": "js/9p.c5be247b.js",
    "revision": null
  },
  {
    "url": "js/9q.484a0b14.js",
    "revision": null
  },
  {
    "url": "js/9qs.5d04568a.js",
    "revision": null
  },
  {
    "url": "js/9s.d7d302d8.js",
    "revision": null
  },
  {
    "url": "js/9u.60b5a151.js",
    "revision": null
  },
  {
    "url": "js/9v.9d4fcb7a.js",
    "revision": null
  },
  {
    "url": "js/9y.e03eb5d9.js",
    "revision": null
  },
  {
    "url": "js/9z.8cc7aec1.js",
    "revision": null
  },
  {
    "url": "js/a2.ea764028.js",
    "revision": null
  },
  {
    "url": "js/a4.b34b1821.js",
    "revision": null
  },
  {
    "url": "js/a9.3d8a01dd.js",
    "revision": null
  },
  {
    "url": "js/a92.00e6cea6.js",
    "revision": null
  },
  {
    "url": "js/ab.75cc9aed.js",
    "revision": null
  },
  {
    "url": "js/ag.9ab26879.js",
    "revision": null
  },
  {
    "url": "js/ak.0f08139e.js",
    "revision": null
  },
  {
    "url": "js/b.c0426f8c.js",
    "revision": null
  },
  {
    "url": "js/b3.293745d9.js",
    "revision": null
  },
  {
    "url": "js/b8.bff4d3af.js",
    "revision": null
  },
  {
    "url": "js/b9.ab986dec.js",
    "revision": null
  },
  {
    "url": "js/ba.0d6f736c.js",
    "revision": null
  },
  {
    "url": "js/base.js.map?_t=45812b22",
    "revision": "b08803b01b67dadedc45284766f201fe"
  },
  {
    "url": "js/base.js?_t=45812b22",
    "revision": null
  },
  {
    "url": "js/bc.86358aea.js",
    "revision": null
  },
  {
    "url": "js/bl.35ac1e33.js",
    "revision": null
  },
  {
    "url": "js/bn.7773ff82.js",
    "revision": null
  },
  {
    "url": "js/bnh.435a285b.js",
    "revision": null
  },
  {
    "url": "js/bo.cde0a6e0.js",
    "revision": null
  },
  {
    "url": "js/bo9.1f4ed20d.js",
    "revision": null
  },
  {
    "url": "js/c0.584c0257.js",
    "revision": null
  },
  {
    "url": "js/c3.036c9acb.js",
    "revision": null
  },
  {
    "url": "js/c8.0a137180.js",
    "revision": null
  },
  {
    "url": "js/ca.67e951ba.js",
    "revision": null
  },
  {
    "url": "js/ca3.dda37b30.js",
    "revision": null
  },
  {
    "url": "js/cc.e331ba52.js",
    "revision": null
  },
  {
    "url": "js/cd.f0e0ca6c.js",
    "revision": null
  },
  {
    "url": "js/cdy.57c1674f.js",
    "revision": null
  },
  {
    "url": "js/ck.e8979f87.js",
    "revision": null
  },
  {
    "url": "js/cm.00a62dde.js",
    "revision": null
  },
  {
    "url": "js/cn.4135095b.js",
    "revision": null
  },
  {
    "url": "js/co.a77d362b.js",
    "revision": null
  },
  {
    "url": "js/cx.238b63d8.js",
    "revision": null
  },
  {
    "url": "js/d.94cb0409.js",
    "revision": null
  },
  {
    "url": "js/d3.f7b1cbf4.js",
    "revision": null
  },
  {
    "url": "js/de.26de5e6d.js",
    "revision": null
  },
  {
    "url": "js/dea.4ac4355c.js",
    "revision": null
  },
  {
    "url": "js/di.c5214134.js",
    "revision": null
  },
  {
    "url": "js/dl.6fa44caf.js",
    "revision": null
  },
  {
    "url": "js/do.d41a8a84.js",
    "revision": null
  },
  {
    "url": "js/dr.5a28e5e0.js",
    "revision": null
  },
  {
    "url": "js/du.c7d2555a.js",
    "revision": null
  },
  {
    "url": "js/dud.4ee763aa.js",
    "revision": null
  },
  {
    "url": "js/e1.ca85c989.js",
    "revision": null
  },
  {
    "url": "js/e3.769063fe.js",
    "revision": null
  },
  {
    "url": "js/e4s.e8078797.js",
    "revision": null
  },
  {
    "url": "js/e9.a9b11f9d.js",
    "revision": null
  },
  {
    "url": "js/ea.1e9e6575.js",
    "revision": null
  },
  {
    "url": "js/eb.5c2a880d.js",
    "revision": null
  },
  {
    "url": "js/ei.89bfb511.js",
    "revision": null
  },
  {
    "url": "js/ep.f456e553.js",
    "revision": null
  },
  {
    "url": "js/epl.c47950e6.js",
    "revision": null
  },
  {
    "url": "js/et.eb6efc65.js",
    "revision": null
  },
  {
    "url": "js/ev.202aafa7.js",
    "revision": null
  },
  {
    "url": "js/ez.fd55cf3a.js",
    "revision": null
  },
  {
    "url": "js/f.f48e2226.js",
    "revision": null
  },
  {
    "url": "js/f7.2bb5fc61.js",
    "revision": null
  },
  {
    "url": "js/fb.7919489a.js",
    "revision": null
  },
  {
    "url": "js/fi.690542d5.js",
    "revision": null
  },
  {
    "url": "js/fm.f30226ae.js",
    "revision": null
  },
  {
    "url": "js/fs.d88226bf.js",
    "revision": null
  },
  {
    "url": "js/fv.fda2ec44.js",
    "revision": null
  },
  {
    "url": "js/fw.7a7aafba.js",
    "revision": null
  },
  {
    "url": "js/fx.ad044b09.js",
    "revision": null
  },
  {
    "url": "js/g.77bbb92d.js",
    "revision": null
  },
  {
    "url": "js/gd.fa642339.js",
    "revision": null
  },
  {
    "url": "js/gl.e9bfd7b4.js",
    "revision": null
  },
  {
    "url": "js/go.d4a0f725.js",
    "revision": null
  },
  {
    "url": "js/gt.759eac0d.js",
    "revision": null
  },
  {
    "url": "js/hd.0ef048ac.js",
    "revision": null
  },
  {
    "url": "js/he.33cafe12.js",
    "revision": null
  },
  {
    "url": "js/hk.f478892b.js",
    "revision": null
  },
  {
    "url": "js/hl.649c30cd.js",
    "revision": null
  },
  {
    "url": "js/hl8.df6d1d67.js",
    "revision": null
  },
  {
    "url": "js/hlj.0f88a395.js",
    "revision": null
  },
  {
    "url": "js/hly.027e2eca.js",
    "revision": null
  },
  {
    "url": "js/hq.b040d039.js",
    "revision": null
  },
  {
    "url": "js/hqg.cd7a80b4.js",
    "revision": null
  },
  {
    "url": "js/hr.4cccf85b.js",
    "revision": null
  },
  {
    "url": "js/i.75a921f5.js",
    "revision": null
  },
  {
    "url": "js/i5.ebb5b48c.js",
    "revision": null
  },
  {
    "url": "js/i7.2172bbf9.js",
    "revision": null
  },
  {
    "url": "js/id.201ed8e2.js",
    "revision": null
  },
  {
    "url": "js/ie.7e1b5c4a.js",
    "revision": null
  },
  {
    "url": "js/ii.97b40174.js",
    "revision": null
  },
  {
    "url": "js/iid.74144de7.js",
    "revision": null
  },
  {
    "url": "js/ij.9941184d.js",
    "revision": null
  },
  {
    "url": "js/ijf.622a29f0.js",
    "revision": null
  },
  {
    "url": "js/io.d9a7693f.js",
    "revision": null
  },
  {
    "url": "js/iu.4db3b6ae.js",
    "revision": null
  },
  {
    "url": "js/j.10ae133e.js",
    "revision": null
  },
  {
    "url": "js/jh.fe2ade8c.js",
    "revision": null
  },
  {
    "url": "js/jr.12afe24f.js",
    "revision": null
  },
  {
    "url": "js/jrt.e5289227.js",
    "revision": null
  },
  {
    "url": "js/js.aab5f491.js",
    "revision": null
  },
  {
    "url": "js/jw.4aa588c1.js",
    "revision": null
  },
  {
    "url": "js/k.ce1bb9fc.js",
    "revision": null
  },
  {
    "url": "js/k1.bdef6063.js",
    "revision": null
  },
  {
    "url": "js/k1w.c279d9eb.js",
    "revision": null
  },
  {
    "url": "js/k9.d8f89d28.js",
    "revision": null
  },
  {
    "url": "js/ka.5ee84118.js",
    "revision": null
  },
  {
    "url": "js/ka0.47b6dff5.js",
    "revision": null
  },
  {
    "url": "js/kd.9d2c0fe6.js",
    "revision": null
  },
  {
    "url": "js/ke.6f9f11f7.js",
    "revision": null
  },
  {
    "url": "js/kj.b01d5abe.js",
    "revision": null
  },
  {
    "url": "js/kk.6ade41b3.js",
    "revision": null
  },
  {
    "url": "js/kx.ae46b82b.js",
    "revision": null
  },
  {
    "url": "js/l1.1fea3209.js",
    "revision": null
  },
  {
    "url": "js/lb.41b9a894.js",
    "revision": null
  },
  {
    "url": "js/lc.8fd6bc2f.js",
    "revision": null
  },
  {
    "url": "js/lg.522e9a15.js",
    "revision": null
  },
  {
    "url": "js/lgt.1f231be7.js",
    "revision": null
  },
  {
    "url": "js/lh.036432d0.js",
    "revision": null
  },
  {
    "url": "js/li.f186279d.js",
    "revision": null
  },
  {
    "url": "js/ll.f463d02f.js",
    "revision": null
  },
  {
    "url": "js/lo.d72c43f9.js",
    "revision": null
  },
  {
    "url": "js/lom.ff4cf8b3.js",
    "revision": null
  },
  {
    "url": "js/loz.ee2e1e47.js",
    "revision": null
  },
  {
    "url": "js/lq.6666e416.js",
    "revision": null
  },
  {
    "url": "js/lw.a74f8d0e.js",
    "revision": null
  },
  {
    "url": "js/ly.fd87d809.js",
    "revision": null
  },
  {
    "url": "js/m3.fa3bf957.js",
    "revision": null
  },
  {
    "url": "js/m3m.4c76dba0.js",
    "revision": null
  },
  {
    "url": "js/m4.cae1f892.js",
    "revision": null
  },
  {
    "url": "js/mb.f84e937b.js",
    "revision": null
  },
  {
    "url": "js/mi.45b5aade.js",
    "revision": null
  },
  {
    "url": "js/mn.213dfcb7.js",
    "revision": null
  },
  {
    "url": "js/mnx.4b39bc1a.js",
    "revision": null
  },
  {
    "url": "js/mo.9a93e6a9.js",
    "revision": null
  },
  {
    "url": "js/mq.c9d8d3d7.js",
    "revision": null
  },
  {
    "url": "js/mr.401e9517.js",
    "revision": null
  },
  {
    "url": "js/my.73e33a8a.js",
    "revision": null
  },
  {
    "url": "js/n.0dad4d66.js",
    "revision": null
  },
  {
    "url": "js/n1.d4981518.js",
    "revision": null
  },
  {
    "url": "js/n2.93e31692.js",
    "revision": null
  },
  {
    "url": "js/n8.84c2c70d.js",
    "revision": null
  },
  {
    "url": "js/n9.547f2cc4.js",
    "revision": null
  },
  {
    "url": "js/na.434d546a.js",
    "revision": null
  },
  {
    "url": "js/nb.54822831.js",
    "revision": null
  },
  {
    "url": "js/nc.c4c3c5e6.js",
    "revision": null
  },
  {
    "url": "js/nd.e074e46f.js",
    "revision": null
  },
  {
    "url": "js/nf.648c2978.js",
    "revision": null
  },
  {
    "url": "js/nh.c0b8331b.js",
    "revision": null
  },
  {
    "url": "js/nj.fd8e32d2.js",
    "revision": null
  },
  {
    "url": "js/nl.77d615a6.js",
    "revision": null
  },
  {
    "url": "js/npm-ag-grid-community.d05bc141.js",
    "revision": null
  },
  {
    "url": "js/npm-ag-grid-react.2b2e46be.js",
    "revision": null
  },
  {
    "url": "js/npm-animate.css.abb0b6b0.js",
    "revision": null
  },
  {
    "url": "js/npm-axe-core.b717f149.js",
    "revision": null
  },
  {
    "url": "js/npm-axe-core_react.3ae08c8b.js",
    "revision": null
  },
  {
    "url": "js/npm-axios.066822fd.js",
    "revision": null
  },
  {
    "url": "js/npm-babel_runtime.15d1d64f.js",
    "revision": null
  },
  {
    "url": "js/npm-beautiful-react-hooks.7327c59b.js",
    "revision": null
  },
  {
    "url": "js/npm-brace.b0a101f3.js",
    "revision": null
  },
  {
    "url": "js/npm-call-bind-apply-helpers.88d7618f.js",
    "revision": null
  },
  {
    "url": "js/npm-call-bound.f1c5e8b2.js",
    "revision": null
  },
  {
    "url": "js/npm-clsx.49029ce6.js",
    "revision": null
  },
  {
    "url": "js/npm-cross-fetch.78f07c1d.js",
    "revision": null
  },
  {
    "url": "js/npm-ctrl_tinycolor.27bcb144.js",
    "revision": null
  },
  {
    "url": "js/npm-dayjs.747fa6a4.js",
    "revision": null
  },
  {
    "url": "js/npm-debug.08ca526c.js",
    "revision": null
  },
  {
    "url": "js/npm-dicetechnology_vesper-sdk-web.6e0da35d.js",
    "revision": null
  },
  {
    "url": "js/npm-domelementtype.0ea27e13.js",
    "revision": null
  },
  {
    "url": "js/npm-domhandler.b38a08f5.js",
    "revision": null
  },
  {
    "url": "js/npm-dunder-proto.9991c04e.js",
    "revision": null
  },
  {
    "url": "js/npm-es-define-property.8aa0ca3f.js",
    "revision": null
  },
  {
    "url": "js/npm-es-errors.31f1a689.js",
    "revision": null
  },
  {
    "url": "js/npm-es-object-atoms.20898dd1.js",
    "revision": null
  },
  {
    "url": "js/npm-exenv.6d5548d8.js",
    "revision": null
  },
  {
    "url": "js/npm-fast-deep-equal.b4d9383c.js",
    "revision": null
  },
  {
    "url": "js/npm-framer-motion.960dca6f.js",
    "revision": null
  },
  {
    "url": "js/npm-function-bind.415060e7.js",
    "revision": null
  },
  {
    "url": "js/npm-ga-gtag.43acc1d6.js",
    "revision": null
  },
  {
    "url": "js/npm-get-intrinsic.4afa7766.js",
    "revision": null
  },
  {
    "url": "js/npm-get-proto.b045c0c5.js",
    "revision": null
  },
  {
    "url": "js/npm-get-user-locale.3d24cad6.js",
    "revision": null
  },
  {
    "url": "js/npm-getstoryteller_storyteller-sdk-javascript.892fccc4.js",
    "revision": null
  },
  {
    "url": "js/npm-gopd.3ff155fb.js",
    "revision": null
  },
  {
    "url": "js/npm-has-symbols.b709e8dd.js",
    "revision": null
  },
  {
    "url": "js/npm-hasown.7eae26a8.js",
    "revision": null
  },
  {
    "url": "js/npm-history.5a8e8414.js",
    "revision": null
  },
  {
    "url": "js/npm-html-dom-parser.446c5818.js",
    "revision": null
  },
  {
    "url": "js/npm-html-parse-stringify.4c6e2ab9.js",
    "revision": null
  },
  {
    "url": "js/npm-html-react-parser.ba11882d.js",
    "revision": null
  },
  {
    "url": "js/npm-i18next-http-backend.18ac56a9.js",
    "revision": null
  },
  {
    "url": "js/npm-i18next.24f54e44.js",
    "revision": null
  },
  {
    "url": "js/npm-immer.f042e56b.js",
    "revision": null
  },
  {
    "url": "js/npm-inline-style-parser.01c3dbab.js",
    "revision": null
  },
  {
    "url": "js/npm-js-cookie.690039cf.js",
    "revision": null
  },
  {
    "url": "js/npm-jsoneditor-react.47377ae4.js",
    "revision": null
  },
  {
    "url": "js/npm-jsoneditor.dbdfca0a.js",
    "revision": null
  },
  {
    "url": "js/npm-lazysizes.a1951e08.js",
    "revision": null
  },
  {
    "url": "js/npm-lit_react.af4fca24.js",
    "revision": null
  },
  {
    "url": "js/npm-load-script.d271f1e4.js",
    "revision": null
  },
  {
    "url": "js/npm-lodash.debounce.1749e7e2.js",
    "revision": null
  },
  {
    "url": "js/npm-lodash.throttle.5005cfb8.js",
    "revision": null
  },
  {
    "url": "js/npm-lottie-react.a7c5ff89.js",
    "revision": null
  },
  {
    "url": "js/npm-lottie-web.85c1d99c.js",
    "revision": null
  },
  {
    "url": "js/npm-math-intrinsics.3d2644f8.js",
    "revision": null
  },
  {
    "url": "js/npm-memoize.011fb280.js",
    "revision": null
  },
  {
    "url": "js/npm-microsoft_applicationinsights-analytics-js.40e194c2.js",
    "revision": null
  },
  {
    "url": "js/npm-microsoft_applicationinsights-cfgsync-js.fb721b25.js",
    "revision": null
  },
  {
    "url": "js/npm-microsoft_applicationinsights-channel-js.7362b3e5.js",
    "revision": null
  },
  {
    "url": "js/npm-microsoft_applicationinsights-core-js.c4984c4b.js",
    "revision": null
  },
  {
    "url": "js/npm-microsoft_applicationinsights-dependencies-js.f00c74eb.js",
    "revision": null
  },
  {
    "url": "js/npm-microsoft_applicationinsights-properties-js.a5441d5f.js",
    "revision": null
  },
  {
    "url": "js/npm-microsoft_applicationinsights-react-js.65a225eb.js",
    "revision": null
  },
  {
    "url": "js/npm-microsoft_applicationinsights-shims.7141f43d.js",
    "revision": null
  },
  {
    "url": "js/npm-microsoft_applicationinsights-web.a634975b.js",
    "revision": null
  },
  {
    "url": "js/npm-microsoft_dynamicproto-js.f04bf5a7.js",
    "revision": null
  },
  {
    "url": "js/npm-mimic-function.1bd6e319.js",
    "revision": null
  },
  {
    "url": "js/npm-motion-dom.c0658625.js",
    "revision": null
  },
  {
    "url": "js/npm-motion-utils.a1ea4364.js",
    "revision": null
  },
  {
    "url": "js/npm-ms.3b2d7ef1.js",
    "revision": null
  },
  {
    "url": "js/npm-nevware21_ts-async.277573b1.js",
    "revision": null
  },
  {
    "url": "js/npm-object-assign.e1924598.js",
    "revision": null
  },
  {
    "url": "js/npm-object-hash.0ddb5063.js",
    "revision": null
  },
  {
    "url": "js/npm-object-inspect.c27232cc.js",
    "revision": null
  },
  {
    "url": "js/npm-prop-types.0c14f5df.js",
    "revision": null
  },
  {
    "url": "js/npm-qs.99c941d6.js",
    "revision": null
  },
  {
    "url": "js/npm-react-animate-on-scroll.b2da9ab7.js",
    "revision": null
  },
  {
    "url": "js/npm-react-calendar.69561889.js",
    "revision": null
  },
  {
    "url": "js/npm-react-dom.935f6053.js",
    "revision": null
  },
  {
    "url": "js/npm-react-fast-compare.e450d1dc.js",
    "revision": null
  },
  {
    "url": "js/npm-react-helmet.65e78654.js",
    "revision": null
  },
  {
    "url": "js/npm-react-i18next.4faeb087.js",
    "revision": null
  },
  {
    "url": "js/npm-react-lifecycles-compat.21547659.js",
    "revision": null
  },
  {
    "url": "js/npm-react-modal-sheet.c1fec0ae.js",
    "revision": null
  },
  {
    "url": "js/npm-react-modal.6535af64.js",
    "revision": null
  },
  {
    "url": "js/npm-react-property.3d625c2d.js",
    "revision": null
  },
  {
    "url": "js/npm-react-router.bfddea08.js",
    "revision": null
  },
  {
    "url": "js/npm-react-schemaorg.65036c59.js",
    "revision": null
  },
  {
    "url": "js/npm-react-side-effect.d628eda7.js",
    "revision": null
  },
  {
    "url": "js/npm-react-swipeable.5205215f.js",
    "revision": null
  },
  {
    "url": "js/npm-react-use-measure.94019a6f.js",
    "revision": null
  },
  {
    "url": "js/npm-react-youtube.56e41ecc.js",
    "revision": null
  },
  {
    "url": "js/npm-react.8b0556d5.js",
    "revision": null
  },
  {
    "url": "js/npm-requestidlecallback.ab2759ee.js",
    "revision": null
  },
  {
    "url": "js/npm-scheduler.02581121.js",
    "revision": null
  },
  {
    "url": "js/npm-side-channel-list.58200ee9.js",
    "revision": null
  },
  {
    "url": "js/npm-side-channel-map.d26ad227.js",
    "revision": null
  },
  {
    "url": "js/npm-side-channel-weakmap.8f98cd09.js",
    "revision": null
  },
  {
    "url": "js/npm-side-channel.894b65ce.js",
    "revision": null
  },
  {
    "url": "js/npm-sister.9c593131.js",
    "revision": null
  },
  {
    "url": "js/npm-stencil_core.0ca693f2.js",
    "revision": null
  },
  {
    "url": "js/npm-stencil_react-output-target.1844d75e.js",
    "revision": null
  },
  {
    "url": "js/npm-style-to-js.4463d714.js",
    "revision": null
  },
  {
    "url": "js/npm-style-to-object.dccf3c5e.js",
    "revision": null
  },
  {
    "url": "js/npm-swc_helpers.c728fd5e.js",
    "revision": null
  },
  {
    "url": "js/npm-swiper.003bc201.js",
    "revision": null
  },
  {
    "url": "js/npm-tanstack_query-core.10abdf3e.js",
    "revision": null
  },
  {
    "url": "js/npm-tanstack_query-devtools.777641bb.js",
    "revision": null
  },
  {
    "url": "js/npm-tanstack_react-query-devtools.c8272f46.js",
    "revision": null
  },
  {
    "url": "js/npm-tanstack_react-query.4d726b30.js",
    "revision": null
  },
  {
    "url": "js/npm-tanstack_react-virtual.2a493741.js",
    "revision": null
  },
  {
    "url": "js/npm-tanstack_virtual-core.37dd2d00.js",
    "revision": null
  },
  {
    "url": "js/npm-uefacom-newdev_liveblog-integration-react.cc1c018b.js",
    "revision": null
  },
  {
    "url": "js/npm-uefadigital_panenka-react.14f9eda4.js",
    "revision": null
  },
  {
    "url": "js/npm-uefadigital_panenka.2379eef2.js",
    "revision": null
  },
  {
    "url": "js/npm-warning.c36d09ca.js",
    "revision": null
  },
  {
    "url": "js/npm-wojtekmaj_date-utils.3287e3a5.js",
    "revision": null
  },
  {
    "url": "js/npm-youtube-player.e4d103ff.js",
    "revision": null
  },
  {
    "url": "js/npm-zustand.05a4713e.js",
    "revision": null
  },
  {
    "url": "js/nq.0ee48281.js",
    "revision": null
  },
  {
    "url": "js/ns.1575b59d.js",
    "revision": null
  },
  {
    "url": "js/nt.94a497a9.js",
    "revision": null
  },
  {
    "url": "js/o.f733f14d.js",
    "revision": null
  },
  {
    "url": "js/o0.fd1aee81.js",
    "revision": null
  },
  {
    "url": "js/o5.fa237e67.js",
    "revision": null
  },
  {
    "url": "js/o7.9c6b4eff.js",
    "revision": null
  },
  {
    "url": "js/o8.533b8d6e.js",
    "revision": null
  },
  {
    "url": "js/ob.ba04783d.js",
    "revision": null
  },
  {
    "url": "js/oc.df544def.js",
    "revision": null
  },
  {
    "url": "js/od.c25113d1.js",
    "revision": null
  },
  {
    "url": "js/og.4977663c.js",
    "revision": null
  },
  {
    "url": "js/og2.37a7fde0.js",
    "revision": null
  },
  {
    "url": "js/ou.b545429e.js",
    "revision": null
  },
  {
    "url": "js/ox.368588ff.js",
    "revision": null
  },
  {
    "url": "js/p.6cf9d9e4.js",
    "revision": null
  },
  {
    "url": "js/p0.0a715f2e.js",
    "revision": null
  },
  {
    "url": "js/p2.a413773d.js",
    "revision": null
  },
  {
    "url": "js/p5.ab2f4452.js",
    "revision": null
  },
  {
    "url": "js/pa.36f409f4.js",
    "revision": null
  },
  {
    "url": "js/pe.54f73433.js",
    "revision": null
  },
  {
    "url": "js/ph.de5a8dba.js",
    "revision": null
  },
  {
    "url": "js/pm.886d2ac3.js",
    "revision": null
  },
  {
    "url": "js/pp.49ae8f18.js",
    "revision": null
  },
  {
    "url": "js/pq.a5e5f5ea.js",
    "revision": null
  },
  {
    "url": "js/pr.9616cab4.js",
    "revision": null
  },
  {
    "url": "js/prl.a0ead625.js",
    "revision": null
  },
  {
    "url": "js/px.2d75b0e1.js",
    "revision": null
  },
  {
    "url": "js/q.f0d36818.js",
    "revision": null
  },
  {
    "url": "js/q1.4eba4f60.js",
    "revision": null
  },
  {
    "url": "js/q9.8b63ee96.js",
    "revision": null
  },
  {
    "url": "js/qa.babe724e.js",
    "revision": null
  },
  {
    "url": "js/qc.ed2e9177.js",
    "revision": null
  },
  {
    "url": "js/qm.a2e030dc.js",
    "revision": null
  },
  {
    "url": "js/qn.4fe1d64b.js",
    "revision": null
  },
  {
    "url": "js/qu.33481ea1.js",
    "revision": null
  },
  {
    "url": "js/r.521845f2.js",
    "revision": null
  },
  {
    "url": "js/r3.2e6030ff.js",
    "revision": null
  },
  {
    "url": "js/r6.7cd0be7f.js",
    "revision": null
  },
  {
    "url": "js/r9.e577217e.js",
    "revision": null
  },
  {
    "url": "js/ra.fa175009.js",
    "revision": null
  },
  {
    "url": "js/rr.5d7fc252.js",
    "revision": null
  },
  {
    "url": "js/rs.4ac900fe.js",
    "revision": null
  },
  {
    "url": "js/rw.af824893.js",
    "revision": null
  },
  {
    "url": "js/ry.1c968764.js",
    "revision": null
  },
  {
    "url": "js/s.ab4cd910.js",
    "revision": null
  },
  {
    "url": "js/s4.6039078c.js",
    "revision": null
  },
  {
    "url": "js/s6.cd22e725.js",
    "revision": null
  },
  {
    "url": "js/s7.a547db4e.js",
    "revision": null
  },
  {
    "url": "js/s9.3641318d.js",
    "revision": null
  },
  {
    "url": "js/s97.95086089.js",
    "revision": null
  },
  {
    "url": "js/sb.14ba2825.js",
    "revision": null
  },
  {
    "url": "js/sc.f61d1009.js",
    "revision": null
  },
  {
    "url": "js/scz.412a7073.js",
    "revision": null
  },
  {
    "url": "js/sd.d08f3405.js",
    "revision": null
  },
  {
    "url": "js/sdj.1f71580f.js",
    "revision": null
  },
  {
    "url": "js/sf.00b14b15.js",
    "revision": null
  },
  {
    "url": "js/sl.3d1cc20f.js",
    "revision": null
  },
  {
    "url": "js/slz.b179c9fe.js",
    "revision": null
  },
  {
    "url": "js/sq.4229588f.js",
    "revision": null
  },
  {
    "url": "js/ss.a2e4f4f6.js",
    "revision": null
  },
  {
    "url": "js/su.22e642bc.js",
    "revision": null
  },
  {
    "url": "js/sz.bd7948d3.js",
    "revision": null
  },
  {
    "url": "js/szy.572d8b2c.js",
    "revision": null
  },
  {
    "url": "js/t.eda8a695.js",
    "revision": null
  },
  {
    "url": "js/t2.1b9ae756.js",
    "revision": null
  },
  {
    "url": "js/ta.fa4b1134.js",
    "revision": null
  },
  {
    "url": "js/te.733c3d37.js",
    "revision": null
  },
  {
    "url": "js/th.e1ea790f.js",
    "revision": null
  },
  {
    "url": "js/tha.d5a4e5fc.js",
    "revision": null
  },
  {
    "url": "js/thd.516840d1.js",
    "revision": null
  },
  {
    "url": "js/thirdparties.js.map?_t=4bf1acfd",
    "revision": "2a0e3ba674b255029efd9356d1768c44"
  },
  {
    "url": "js/thirdparties.js?_t=4bf1acfd",
    "revision": null
  },
  {
    "url": "js/tl.3ec6d482.js",
    "revision": null
  },
  {
    "url": "js/to.68601da3.js",
    "revision": null
  },
  {
    "url": "js/tt.99cc687d.js",
    "revision": null
  },
  {
    "url": "js/tu.3a2e435f.js",
    "revision": null
  },
  {
    "url": "js/tu5.4edb4c53.js",
    "revision": null
  },
  {
    "url": "js/ty.b10640d6.js",
    "revision": null
  },
  {
    "url": "js/u.9651f081.js",
    "revision": null
  },
  {
    "url": "js/u4.a46331a3.js",
    "revision": null
  },
  {
    "url": "js/u8.1f8a994d.js",
    "revision": null
  },
  {
    "url": "js/uc.2856e8c4.js",
    "revision": null
  },
  {
    "url": "js/ucn.44ea1850.js",
    "revision": null
  },
  {
    "url": "js/ul.1283f59a.js",
    "revision": null
  },
  {
    "url": "js/uln.f73fdf92.js",
    "revision": null
  },
  {
    "url": "js/ur.017068e1.js",
    "revision": null
  },
  {
    "url": "js/uw.f60909e4.js",
    "revision": null
  },
  {
    "url": "js/v.423c0b5e.js",
    "revision": null
  },
  {
    "url": "js/v4.6bb71d45.js",
    "revision": null
  },
  {
    "url": "js/vb.fa45144b.js",
    "revision": null
  },
  {
    "url": "js/vc.a2f87423.js",
    "revision": null
  },
  {
    "url": "js/vd.e027bfe4.js",
    "revision": null
  },
  {
    "url": "js/vda.b5f530d8.js",
    "revision": null
  },
  {
    "url": "js/vh.3d231214.js",
    "revision": null
  },
  {
    "url": "js/vj.95dbcc73.js",
    "revision": null
  },
  {
    "url": "js/vl.0f447b31.js",
    "revision": null
  },
  {
    "url": "js/vm.1716a6da.js",
    "revision": null
  },
  {
    "url": "js/vn.84930fb2.js",
    "revision": null
  },
  {
    "url": "js/vnc.93f3a122.js",
    "revision": null
  },
  {
    "url": "js/void.js.map?_t=e45b8a22",
    "revision": "9eab7bf5764778e36ccf40b3d4fe1c4d"
  },
  {
    "url": "js/void.js?_t=e45b8a22",
    "revision": null
  },
  {
    "url": "js/vp.d12c6cae.js",
    "revision": null
  },
  {
    "url": "js/vq.b8c27956.js",
    "revision": null
  },
  {
    "url": "js/vs.3ea36886.js",
    "revision": null
  },
  {
    "url": "js/vz.3260065c.js",
    "revision": null
  },
  {
    "url": "js/w.cc73f2ee.js",
    "revision": null
  },
  {
    "url": "js/w0.cee15239.js",
    "revision": null
  },
  {
    "url": "js/w8.c01800ac.js",
    "revision": null
  },
  {
    "url": "js/wa.d2932577.js",
    "revision": null
  },
  {
    "url": "js/wad.8a71fa2a.js",
    "revision": null
  },
  {
    "url": "js/wd.5d849252.js",
    "revision": null
  },
  {
    "url": "js/we.ce4a575a.js",
    "revision": null
  },
  {
    "url": "js/wq.45fd42ab.js",
    "revision": null
  },
  {
    "url": "js/ws.8ada454c.js",
    "revision": null
  },
  {
    "url": "js/ww.dbccdf71.js",
    "revision": null
  },
  {
    "url": "js/wx.3f928f10.js",
    "revision": null
  },
  {
    "url": "js/x.2acdcd95.js",
    "revision": null
  },
  {
    "url": "js/x8.293b8c86.js",
    "revision": null
  },
  {
    "url": "js/xc.ffdb6861.js",
    "revision": null
  },
  {
    "url": "js/xr.9007b2b0.js",
    "revision": null
  },
  {
    "url": "js/xt.41da13f3.js",
    "revision": null
  },
  {
    "url": "js/y.6e69e78f.js",
    "revision": null
  },
  {
    "url": "js/y3.fe689c92.js",
    "revision": null
  },
  {
    "url": "js/y5.2b88c84a.js",
    "revision": null
  },
  {
    "url": "js/ya.5ff979dc.js",
    "revision": null
  },
  {
    "url": "js/yb.caf6626a.js",
    "revision": null
  },
  {
    "url": "js/ye.7ab91bce.js",
    "revision": null
  },
  {
    "url": "js/yi.62a97525.js",
    "revision": null
  },
  {
    "url": "js/yj.ce802f39.js",
    "revision": null
  },
  {
    "url": "js/yp.749cb24d.js",
    "revision": null
  },
  {
    "url": "js/yq.ce6c4d03.js",
    "revision": null
  },
  {
    "url": "js/yt.e64429b8.js",
    "revision": null
  },
  {
    "url": "js/yz.d148b6f5.js",
    "revision": null
  },
  {
    "url": "js/z.a8832472.js",
    "revision": null
  },
  {
    "url": "js/z0.550ad5c5.js",
    "revision": null
  },
  {
    "url": "js/z2.ac9448d8.js",
    "revision": null
  },
  {
    "url": "js/ze.ac178d2c.js",
    "revision": null
  },
  {
    "url": "js/zg.35f97425.js",
    "revision": null
  },
  {
    "url": "js/zj.1b26a03a.js",
    "revision": null
  },
  {
    "url": "js/zm.78e1b11a.js",
    "revision": null
  },
  {
    "url": "js/zo.12a6e980.js",
    "revision": null
  },
  {
    "url": "js/zs.1f500230.js",
    "revision": null
  },
  {
    "url": "js/zsa.2d256575.js",
    "revision": null
  }
], {});




workbox_routing_registerRoute(({ event, url, sameOrigin }) =>
    (sameOrigin || url.hostname.endsWith('uefa.com')) && event.request.destination === 'image', new workbox_strategies_StaleWhileRevalidate({ "cacheName":"images", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 15 })] }), 'GET');
workbox_routing_registerRoute(({ event, url, sameOrigin }) =>
    (sameOrigin || url.hostname.endsWith('uefa.com')) && event.request.destination === 'script', new workbox_strategies_StaleWhileRevalidate({ "cacheName":"javascript", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 15 })] }), 'GET');
workbox_routing_registerRoute(({ event, url, sameOrigin }) =>
    (sameOrigin || url.hostname.endsWith('uefa.com')) && event.request.destination === 'style', new workbox_strategies_StaleWhileRevalidate({ "cacheName":"stylesheets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 15 })] }), 'GET');
workbox_routing_registerRoute(({ event, url, sameOrigin }) =>
    (sameOrigin || url.hostname.endsWith('uefa.com')) && event.request.destination === 'font', new workbox_strategies_StaleWhileRevalidate({ "cacheName":"fonts", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 15 })] }), 'GET');
workbox_routing_registerRoute(({ event, url, sameOrigin }) =>
    (sameOrigin || url.hostname.endsWith('uefa.com')) && event.request.destination === 'document', new workbox_strategies_NetworkFirst({ "cacheName":"html", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 10 })] }), 'GET');




